{
  "settings": {
    "calendar": {
      "calendar_settings": "Kalenderinnstillinger",
      "settings": "Innstillinger",
      "select_calendar_type": "Velg kalendertype",
      "add_new_calendar_group": "Legg til ny kalendergruppe",
      "add_new_equipment": "Legg til nytt utstyr",
      "new_calendar": "Ny kalender",
      "calendar_group_description": "Bruk kalender Gruppe for å effektivt sortere og gruppere flere kalendere sammen.",
      "group": "Gruppe",
      "manage_your_calendars_and_groups": "Administrer kalenderne og gruppene dine",
      "groups": "Gruppe",
      "create_group": "Opprett gruppe",
      "create_calendar": "Opprett kalender",
      "calendar_name": "Kalendernavn",
      "group_duration": "Gruppevarighet",
      "calendar_type": "Type",
      "action": "Handling",
      "round_robin": "Rotasjonsordning",
      "event": "Hendelse",
      "group_name": "Gruppenavn",
      "room_name": "Navn på rommet",
      "group_description": "Gruppebeskrivelse",
      "calendar_url": "Kalender-URL",
      "calendars": "Kalendere",
      "date_updated": "Oppdatert dato",
      "status": "Status",
      "action_dropdown": "Handling-rullegardinmeny",
      "calendar_list": "Tjenester tilknyttet",
      "edit": "Redigere",
      "duplicate": "Dupliser",
      "copy_embed_code": "Kopier innebygd kode",
      "copy_permanent_link": "Kopier permanent lenke",
      "copy_new_slug_link": "Kopier planleggingslenke",
      "copy_scheduling_link": "Kopier planleggingslenke (utgått eldre versjon)",
      "deactivate_calendar": "Deaktiver kalender",
      "move_to_group": "Flytte til Gruppe",
      "delete_calendar": "Slett kalender",
      "delete_group": "Slett",
      "delete_this_group": "Slett denne gruppen",
      "activate_calendar": "Aktiver kalender",
      "duration": "Varighet",
      "all": "hver eneste",
      "draft": "Utkast",
      "inactive": "Inaktiv",
      "active": "Aktiv",
      "actions": "aktiviteter",
      "rearrange_calendars": "Omorganiser kalendere",
      "deactivate_all_calendars_in_group": "Deaktivere hver eneste kalendere in Gruppe",
      "activate_all_calendars_in_group": "trigger hver eneste kalendere in Gruppe",
      "no_groups_found": "Søket ditt samsvarte ikke med noen kalendergruppe.",
      "no_groups_in_location": "Gruppe Sorterer kalenderne dine som Mappe. Legge til kalendere til en gruppe og dele en Individuell Planleggingslenke, la Booker Velge Fra flere kalendere.",
      "no_calendars_found": "Kom i gang Via kalender Via Opprettet ny kalender.",
      "no_calendars_found_search": "Din Søke samsvarte ikke med noen kalendere.",
      "delete_calendar_message": "Du're Om å slette kalenderen. Når Du Visninger sletter det, vil det også slette hver eneste sin Avtale.",
      "delete_calendar_message_title": "Slette denne kalenderen?",
      "duplicate_calendar_message": "Du er i ferd med å duplisere kalenderen. Dette vil opprette en ny kalender med de samme innstillingene som den valgte kalenderen.",
      "duplicate_calendar_message_title": "Dupliser denne kalenderen?",
      "no_calendars_found_title": "Fant ingen kalendere",
      "no_groups_in_location_title": "Fant ingen grupper",
      "delete_group_confirmation_title": "Vil du slette denne gruppen?",
      "delete_group_confirmation": "Er du sikker på at du ønsker å slette Valgt-gruppen?",
      "delete_group_confirmation_checkbox_title": "Slett Medlemmer-kalendere og Avtale",
      "delete_group_confirmation_checkbox_description": "Hvis du velger dette alternativet, slettes også kalenderne in denne gruppen, sammen med hver eneste Avtale in disse kalenderne.",
      "group_status_message_title": "{status} gruppen og alle tilknyttede kalendere?",
      "calendar_status_message_title": "{status} denne kalenderen?",
      "calendar_status_message": "Du er i ferd med å {status} kalenderen.",
      "group_status_active_message": "Er du sikker på at du vil aktivere denne gruppen? Alle kalendere i gruppen vil også bli aktivert og gjort tilgjengelige for booking.",
      "group_status_inactive_message": "Er du sikker på at du vil deaktivere denne gruppen? Alle kalendere i gruppen vil også bli deaktivert og gjort tilgjengelige for booking.",
      "coming_soon": "Kommer snart",
      "select": "Velge",
      "15mins": "15 minutter",
      "cancel": "Kansellere",
      "save": "Arkivere",
      "create": "Skape",
      "select_calendar_group": "Velg kalendergruppe",
      "move_calendar_confirmation": "Vær oppmerksom på at arven Lenke ville slutte å fungere når Du Fortsette med Endre. Vennligst bekreft Via å velge Avmerkingsboks.",
      "previously_called_unassigned": " (Tidligere kalt som ikke tilordnet)",
      "scheduling_type": "Velg kalendertype",
      "scheduling_type_description": "Velg en Kalendertype for å konfigurere kalenderen din og tilpasse hvordan Avtale er planlagt.",
      "service_menu_name": "Navn på tjenestemeny",
      "template": "Mal",
      "select_template": "Velg mal",
      "group_url": "Gruppe -URL",
      "template_description": "Du kan nå velge enten Classic- eller Neo-malene for gruppevisningen.",
      "rooms": "Rom",
      "rooms_name": "Navn",
      "rooms_description": "Beskrivelse",
      "rooms_modal_description": "Legg til eller rediger rom.",
      "rooms_capacity": "Total kapasitet",
      "no_rooms_in_location_title": "Ingen rom funnet",
      "no_rooms_in_location": "Ingen rom funnet in dette stedet",
      "no_equipments_in_location": "Ingen Utstyr funnet in dette Stedet",
      "equipments": "Utstyr",
      "equipment_name": "Navn",
      "equipment_name_search": "Navn på Utstyr",
      "equipment_description": "Beskrivelse",
      "equipment_modal_description": "Legg til eller rediger et utstyr.",
      "add_equipment": "Legge til/ Redigere Utstyr",
      "add_room": "Legge til/ Redigere Rom",
      "equipment_quantity": "Total mengde",
      "equipment_outOfService": "Fra antall tjenester",
      "no_equipments_in_location_title": "Ingen Utstyr funnet",
      "delete_this_equipment": "Slett dette Utstyr",
      "delete_this_rooms": "Slett denne rom-en",
      "delete_equipment_confirmation": "Er du sikker på at du vil slette dette Utstyr? This will be Slettet Fra hver eneste the Tredjepartskalendere also.",
      "delete_rooms_confirmation": "Er du sikker på at du vil slette denne ROM-en? This will be Slettet Fra hver eneste the Tredjepartskalendere also.",
      "add_new_calendar_equipments": "Legge til ny Utstyr",
      "no_equipments_found": "Søket ditt samsvarte ikke med noe Utstyr.",
      "no_rooms_found": "Søket ditt samsvarte ikke med noen rom.",
      "add_new_calendar_rooms": "Legge til ny Rom",
      "rooms_disable": "Deaktiver Rom",
      "equipments_disable": "Deaktiver Utstyr",
      "equipments_activate": "trigger Utstyr",
      "rooms_activate": "trigger Rom",
      "create_equipments": "Skape Utstyr",
      "create_rooms": "Skape Rom",
      "select_calendar_rooms_title": "Velge kalender",
      "select_calendar_rooms_description": "Du kan velge flere kalendere som skal knyttes til rom.",
      "select_calendar_equipments_title": "Velge kalender",
      "select_calendar_equipments_description": "Du kan velge én kalender som skal knyttes til utstyret.",
      "disable_equipment_title": "{status} Utstyr",
      "disable_room_title": "{status} Rom",
      "equipments_status_message": "Er du sikker på at du vil {status} dette Utstyr?",
      "rooms_status_message": "Er du sikker på at du vil {status} denne rom-en?",
      "calendar_resource_disclaimer": "Dette kan påvirke Tilgjengelighet på Medlemmers tjenestekalendere.",
      "equipment_disclaimer": "Merk: Å aktivere Utstyr senere vil automatisk Koble til på nytt det til kalenderne det er Medlemmer med",
      "room_disclaimer": "Merk: Å aktivere ROM-en senere vil automatisk Koble til på nytt den til kalenderne den er Medlemmer med",
      "equipment_tab_name": "Utstyr",
      "rooms_tab_name": "Rom",
      "manage_your_rooms": "Administrere Rom for din Virksomhet her",
      "manage_your_equipments": "Administrere Utstyr for ditt Virksomhet her",
      "select_service_calendar_description_equipments": "Du kan velge flere tjenestekalendere som skal knyttes til utstyret.",
      "select_service_calendar_description_rooms": "Du kan velge flere tjenestekalendere som skal knyttes til rommet.",
      "service_menus": "Tjenestemeny",
      "manage_your_calendars_groups_and_service_menus": "Administrer kalenderne, gruppene og servicemenyene dine",
      "new_service_menu": "Skape tjenestemeny",
      "deactivate_service_menu": "Deaktiver tjenestemeny",
      "delete_service_menu": "Slett denne tjenestemenyen",
      "delete_service_menu_confirmation": "Er du sikker på at du vil slette denne tjenestemenyen?",
      "service_menu_status_message_title": "{status} denne tjenestemenyen?",
      "service_menu_status_message": "Du er i ferd med å {status} tjenestemenyen.",
      "no_service_menus_in_location_title": "Skape din tilpassede tjenestemeny",
      "add_new_service_menu": "Legge til ny tjenestemeny",
      "no_service_menus_in_location": "Start Via Opprettet en ny tjenestemeny og legg til Gruppe i den",
      "no_service_menu_found": "Ingen tjenestemeny funnet",
      "no_service_menu_found_desc": "Din Søke samsvarte ikke med noen tjenestemenyer.",
      "apply": "Iverksette",
      "troubleshoot_calendar": "Feilsøking av kalender",
      "round_robin_booking": "Rotasjonsordning",
      "round_robin_description": "Fordeler Avtale blant Gruppe Medlemmer in en roterende Sortere.",
      "round_robin_example": "F.eks.: Salg-anrop, Onboarding økter.",
      "unassigned_booking": "Hendelse",
      "unassigned_description": "For Planlegge fysiske hendelser uten Vert Forhold.",
      "unassigned_example": "F.eks.: Konferanser, offentlige seminarer, utstillinger.",
      "event_booking_alert_title": "Viktig",
      "event_booking_alert_message": "Denne kalendertypen har viktige forskjeller.",
      "event_booking_learn_more": "Les mer",
      "event_booking_tooltip_title": "Ting du bør vite:",
      "event_booking_tooltip_content": "• Hendelseskalendere har ingen brukere, så møter kan ikke tilordnes til en bruker.\n• Fordi ingen bruker er tilordnet, støttes ikke dynamiske møtelenkeverktøy (Zoom, Google Meet, Microsoft Teams). Hvis du vil bruke nettmøter, kopierer du en statisk konferanselenke fra et hvilket som helst verktøy og limer den inn i møtestedet.\n• Fordi ingen bruker er tilordnet, synkroniseres ikke møter til en brukers kalender fra Kalenderinnstillinger → Forbindelser. Konfliktkalendere som legges til der, blir ikke tatt med i betraktningen.\n• Møter synkroniseres kun til kalenderen som er valgt under Ekstern synkronisering for denne kalenderen.\n• Hendelser hentes fra og sendes kun til den valgte eksterne kalenderen.\n• Bare én Google-kalender kan kobles til ved hjelp av ekstern synkronisering.",
      "class_booking": "Klasse",
      "class_booking_description": "One Vert møter flere medlemmer.",
      "class_booking_example": "F.eks.: webinarer, gruppekurs, online -kurs.",
      "collective_booking": "KOLLEKTIV Booking",
      "collective_booking_description": "Flere verter møtes med en medlem.",
      "collective_booking_example": "F.eks.: Panelintervjuer, utvalgsvurderinger.",
      "service_booking": "Tjenestebestilling",
      "service_booking_description": "Sømløs Planlegge for tjenestebaserte virksomheter.",
      "service_booking_example": "Eks: Spa Avtale, reparasjon Tjenester, konsultasjoner.",
      "personal_booking": "Personlig bestilling",
      "personal_booking_description": "Planlegge en-på-en-møter med en spesifikk Gruppe Medlemmer.",
      "personal_booking_example": "F.eks.: Kundemøter, private konsultasjoner.",
      "personal": "Personlig",
      "explore_more_types": "Utforsk flere Kategorier",
      "no_calendars_added": "Ingen kalendere ennå – Samling en opp!",
      "no_calendars_added_description": "Skap din første kalender for å starte Planlegge uten problemer.",
      "no_groups_added": "Ingen gruppe ennå – Begynn å organisere deg!",
      "no_calendars_yet": "Ingen kalendere ennå",
      "no_groups_yet": "Ingen gruppe ennå",
      "no_calendars_access": "Ingen kalendere er blitt opprettet ennå. Når en kalender er Opprettet, vil den vises henne. Du har ikke Tilgang for å Skape en kalender – ta kontakt med Admin din hvis nødvendig.",
      "no_groups_access": "Ingen grupper har blitt konfigurert ennå. Når en gruppe er Opprettet, vil den vises henne. Du har ikke Tilgang for å Skape a Gruppe – ta kontakt med Admin din hvis nødvendig.",
      "no_groups_added_description": "Bruk Gruppe for å se kalenderne dine strukturert. Legge til kalendere til en gruppe og Slett en individuell gruppeplanleggingslenke for enkel booking.",
      "group_success_message": "Gruppe er vellykket opprettet. Du kan nå Inkludere kalendere til denne gruppen.",
      "choose_calendars": "Velge kalendere",
      "do_it_later": "Jeg gjør det senere",
      "add_calendars_to_group": "Legge til kalendere i Gruppe",
      "select_calendars_to_add": "Vennligst velg hver eneste kalenderne du ønsker å inkludere i gruppen {name}",
      "add_calendars": "Legge til kalender(er)",
      "continue": "Fortsette",
      "conflicting_calendars": "Motstridende kalendere",
      "conflicting_calendars_description": "Etterfølgende-kalenderne er allerede en del av Annen/annet Gruppe. Vil du overføre dem til din nye gruppe, <b>{name}</b>?",
      "group_associated_with": "Nåværende Gruppe",
      "move_calendar_consent": "Jeg Aktivere Flytte disse kalenderne til ny Gruppe.",
      "calendars_moved_successfully": "hver eneste Valgt-kalendrene er blitt flyttet til {name}.",
      "new_group": "Ny gruppe",
      "back": "Tilbake",
      "share_otl": "Slett din Tilgjengelighet hver eneste Dato med en unik Lenke som Utløper Etter en booking, og sikrer Administrere Tilgang.",
      "copied_to_clipboard": "Kopiert til utklippstavlen",
      "generate_link": "Generer ny lenke",
      "generate_link_error": "Kunne ikke generere en engangslenke. Prøv igjen",
      "share_schedule_link": " Planleggingslenke bestemmes Via Slug. Endre the Slug, og Planleggingslenke tilpasser seg automatisk modifikasjonen.",
      "share_permanent_link": "Ideell for Trakter, Nettsted Omdirigeringer, Eller Reklame, den permanente Lenke forblir konstant, upåvirket Via Slug Dynamisk.",
      "copy": "Kopiere",
      "share_embed_code": "Plasser denne koden in HTML en din der du vil at {embedType} Widget skal vises.",
      "scheduling_link": "Planleggingslenke",
      "permanent_link": "Permanent lenke",
      "one_time_link": "Engangslenke",
      "embed_code": "Sett inn kode",
      "loading": "Laster...",
      "share_group": "Del gruppe",
      "edit_group": "Rediger gruppe",
      "more_options": "Flere alternativer",
      "share_calendar": "Del kalender",
      "edit_calendar": "Rediger kalender",
      "troubleshoot_calendar_link": "Feilsøk kalender",
      "calendar_config_success": "Du har konfigurert din personlige kalender/Gruppe-kalender",
      "close": " Lukke",
      "added_calendars": "Kalender(e) som er lagt til",
      "select_calendars": "Velge kalender(er)",
      "settings_confirmation": "Til Fortsette, vennligst bekreft disse Dynamisken.",
      "consent_checkbox_title": "Jeg forstår og godtar disse endringene.",
      "confirm": "Bekreft",
      "create_group_access_disabled": "Du har ikke Autorisasjon til Skape a Gruppe. Ta kontakt med Admin din for Tilgang.",
      "create_calendar_access_disabled": "Du har ikke Autorisasjon for å Skape en kalender. Ta kontakt med Admin din for Tilgang.",
      "preview_booking_widget": "Forhåndsvisning av bestillingswidget",
      "share_service_menu": "Del tjenestemeny",
      "back_message": "Tilbake til listen over kalendere",
      "service_calendars": "Tjenestekalendere",
      "owned_by": "Eid Via",
      "owned_by_anyone": "Hvem som helst",
      "owned_by_me": "Meg",
      "all_groups": "Alle grupper",
      "all_calendars": "Alle kalendere",
      "not_grouped": "Ikke gruppert",
      "delete_group_desc": "Er du sikker på at du vil slette denne gruppen? Dette vil også slette hver eneste kalenderne som er medlemmer med denne gruppen.",
      "calendar_listing_title": "Kalenderliste",
      "calendar_group_name": "Kalender-/gruppenavn",
      "success": "Vellykket",
      "my_calendar": "min-kalender",
      "service_calendar_description": "Sømløs planlegging for tjenestebedrifter."
    },
    "preferences": {
      "preferences": "Innstillinger",
      "my_preferences": "Mine Preferanse",
      "account_preferences": "Kontoinnstillinger",
      "user_preferences": "Bruker Innstillinger",
      "set_preferences": "Samling av Innstillinger for Kontoen din.",
      "scheduling_options": "Planlegge Alternativer",
      "meeting_location": "Møtested",
      "zoom": "Zoom",
      "save_preferences": "Arkivere Innstillinger",
      "in_app_preferences": "I App Innstillinger",
      "set_start_day": "Samling Innstillinger Like start Dag for appen",
      "view_options": "Se Alternativer",
      "services": "Tjenester",
      "feature_toggle_aria": "Funksjonsveksler",
      "week_starts_on": "Uken starter på",
      "sunday": "Søndag",
      "widget_preferences": "Widget Innstillinger",
      "set_widget_language": "Samling Innstillinger Like Språk for Widget",
      "language_and_region": "Språk og Stat",
      "language": "Språk",
      "english": "Engelsk",
      "time_format": "Tidsformat",
      "time_format_value": "PM",
      "monday": "Mandag",
      "custom_meeting_location": "Tilpasset Konferanse Sted",
      "view_appointments_in_1": "Se avtaler i",
      "timezone_uses_details_1": "Vi vil bruke denne tidssonen til å vise Avtaletider i hele appen og i e-postene dine relatert til Avtaler – kun for deg. Det vil ikke påvirke tilgjengeligheten din eller hvordan andre bestiller hos deg.",
      "business_timezones_1": "Bedriftens tidssone",
      "business_timezones_tooltip_1": "Melding: Ved å velge dette alternativet sikrer du at dine visningspreferanser samsvarer med den valgte bedriftstidssonen. Hvis bedriftens tidssone endres, vil visningstidssonen automatisk justeres for å samsvare.",
      "recommended_timezones": "Anbefalte tidssoner",
      "all_timezones": "Alle tidssoner"
    },
    "availability": {
      "availability": "Tilgjengelighet",
      "my_availability": "Min tilgjengelighet",
      "my_availability_and_booking_rules": "Tilgjengelighetsplan",
      "my_availability_and_booking_rules_description": "Angi når møter kan bookes basert på de ansattes tilgjengelighet.",
      "account_availability": "Kontotilgjengelighet",
      "timezone": "Tidssone",
      "working_hours": "Arbeidstider",
      "set_recurring_hours": "Samling av Gjentakende arbeidstid for Konferanse",
      "select_one": "Velg én",
      "sunday": "Søndag",
      "monday": "Mandag",
      "tuesday": "Tirsdag",
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lørdag",
      "widget_preferences": "Widget Innstillinger",
      "set_widget_language": "Samling Innstillinger Like Språk for Widget",
      "language_and_region": "Språk og Stat",
      "language": "Språk",
      "english": "Engelsk",
      "copy_to_all": "Kopiere til hver eneste",
      "save_availability": "Lagre tilgjengelighet",
      "add_time": "Legg til tid",
      "to": "Til",
      "select_time": "Velg tid",
      "add_user": "Legg til bruker",
      "accessRestricted": {
        "header": "Tilgang Privat",
        "message": "Du er ikke en del av denne kontoen. For å få tilgang må du legge til deg selv på denne kontoen via Byråinnstillinger > Team > Rediger teammedlem, og tilordne kontoen under \"Roller og tillatelser\".",
        "contact_admin": "Denne siden er kun offentlig for administratorer. Ta kontakt med Admin din for å få hjelp.",
        "button_text": "Gå til Byråinnstillinger."
      },
      "schedule": {
        "edit_schedule": "Rediger plan",
        "schedule_name": "Navn på plan",
        "schedule_name_required": "Navnet på planen er påkrevd",
        "timezone": "Tidssone",
        "timezone_placeholder": "Velg en",
        "start_time": "Starttid",
        "end_time": "Sluttid",
        "add_availability_hour": "Legg til ledig time",
        "remove_availability_hour": "Fjern ledig time",
        "unavailable": "Ikke ledig",
        "schedule_created": "Planen ble opprettet",
        "schedule_updated": "Planen er oppdatert",
        "calendars_selected": "{count} kalender",
        "calendars_selected_multiple": "{count} kalendere",
        "select_users_placeholder": "Søk etter brukere",
        "edit_default_schedule": "Rediger denne timeplanen",
        "customize_event_type_schedule": "Tilpass timeplanen kun for denne kalenderen",
        "multi_user_description": "<b>{count} brukere</b> er valgt, oppdater deres ledige tid for <b>{calendar}</b>.",
        "selected_calendar": "valgt kalender",
        "edit_schedule_alert": "Oppdateringer som gjøres her vil gjelde for",
        "schedule": "Timeplan",
        "no_availability": "Ingen tilgjengelighet",
        "date_specific_hours_show_more": "mer",
        "date_specific_hours_show_less": "mindre",
        "date_specific_hours_recurring_meetings_enabled": "Datospesifikke timer kan ikke legges til fordi denne planen er koblet til en kalender med gjentakende møter aktivert. Deaktiver gjentakende møter for å fortsette.",
        "recurring_incompatible_with_date_hours": "Gjentatte møter kan ikke aktiveres fordi brukerens timeplan har datospesifikke tider, noe som er inkompatibelt.",
        "incompatible_schedule_with_recurring": "{user} planen inneholder dato-spesifikke timer, som ikke er kompatible med gjentakende møter.",
        "incompatible_schedule_with_recurring_calendar": "Planen inneholder dato-spesifikke timer, som ikke er kompatible med gjentakende møter.",
        "recurring_meetings_enabled_multi_user": "Gjentatte møter støttes ikke for kalendere med flere teammedlemmer eller når et teammedlem har datospesifikke timer lagt til i timeplanen sin.",
        "weekdays": "Hverdager, {timeRange}",
        "weekdays_hours_vary": "Hverdager, åpningstider varierer",
        "weekend": "Helg, {timeRange}",
        "weekend_hours_vary": "Helg, åpningstider varierer",
        "days_hours_vary": "{days}, åpningstider varierer",
        "date_specific_hours_tab_name": "Datospesifikke tider",
        "date_specific_hours": "{count} dato-spesifikke åpningstider",
        "date_specific_hours_1": "1 dato-spesifikk tid",
        "weekly_hours": "Ukentlige timer",
        "custom_schedule": "Tilpasset plan",
        "select_schedule": "Velg en plan",
        "no_schedules_found": "Fant ingen planer",
        "untitled": "Uten tittel",
        "error_updating_schedules": "Feil under oppdatering av tidsplaner",
        "daily": "Daglig",
        "weekly": "Ukentlig",
        "monthly": "Månedlig",
        "custom": "Egendefinert",
        "this_is_required": "Dette er obligatorisk",
        "search": "Søke",
        "edit_hours": "Rediger åpningstider",
        "schedule_name_duplicate": "En timeplan med dette navnet finnes allerede",
        "delete_schedule_title": "Slette \"{scheduleName}\" plan?",
        "delete_schedule_description": "Denne handlingen kan ikke angres. Er du sikker på at du vil fortsette?",
        "delete_schedule_negative_text": "Kanseller",
        "delete_schedule_positive_text": "Ja, slett.",
        "active_on": "Aktiv På",
        "weekly_working_hours": "Ukentlige arbeidstimer",
        "weekly_working_hours_subtext": "Velg dager og tidspunkter du jobber på",
        "copy_availability_hour": "Kopier ledig time",
        "mins": "Minutter",
        "hours": "Timer",
        "bulk_edit_warning_banner": "Bulk-redigering aktivert. Endringer vil overskrive de eksisterende planene for alle valgte brukere.",
        "bulk_edit_slot_applies_to_all": "Valgt tidsluke vil gjelde for alle valgte brukere.",
        "bulk_edit_slot_applies_to_selected": "Valgt tidsluke vil gjelde for {count} valgte brukere.",
        "bulk_edit_applies_to_all": "Endringene vil gjelde for alle {count} valgte brukere.",
        "bulk_edit_weekly_hours": "Bulkredigering av ukentlige arbeidstimer",
        "bulk_edit_weekly_hours_title": "Bulkredigering av ukentlige arbeidstimer",
        "bulk_edit_weekly_hours_desc": "Dette vil erstatte de ukentlige timene for alle brukerne som er oppført nedenfor.",
        "edit_now": "Rediger nå",
        "bulk_edit": "Bulkredigering",
        "choose_days_weekly_hours": "Velg dagene for å angi ukentlig arbeidstid",
        "assign_to": "Tildel til:",
        "configure_weekly_hours": "Konfigurer ukentlige arbeidstimer",
        "selected_users": "Valgte brukere:",
        "bulk_edit_select_users": "Velg relevante brukere",
        "bulk_edit_select_users_placeholder": "Velg teammedlemmer ...",
        "bulk_edit_select_at_least_one": "Velg minst én bruker",
        "bulk_edit_editing_for": "Redigering for:",
        "bulk_edit_applies_to": "Gjelder for:",
        "bulk_edit_user_count": "{count} bruker",
        "bulk_edit_users_count": "{count} brukere",
        "show_less": "Vis mindre",
        "more": "mer",
        "confirm_delete": "Bekreft sletting",
        "confirm": "Bekreft",
        "delete_user_date_confirm": "Er du sikker på at du vil slette de dato-spesifikke timene for <b>{userName}</b> på <b>{date}</b>?",
        "delete_date_confirm": "Er du sikker på at du vil slette de dato-spesifikke timene for alle brukere på <b>{date}</b>?",
        "save_weekly_hours": "Lagre ukentlige timer",
        "save_date_specific_hours": "Lagre datospesifikke timer",
        "update_weekly_hours_for_users": "Oppdater ukentlige timer for {count} brukere",
        "set_date_specific_hours_for_users": "Angi datospesifikke timer for {count} brukere",
        "set_date_specific_hours_for_user": "Angi datospesifikke timer"
      }
    },
    "connections": {
      "connections": "Tilkoblinger",
      "connect": "koble til",
      "conferencing": "Konferanse",
      "my_connections": "Mine tilkoblinger",
      "account_connections": "Konto",
      "connection_preferences": "Tilknytning Innstillinger",
      "manage_calendars_conferencing_channels": "Administrere kalendere og Konferanse",
      "main_integration_calendar": "PRIMÆR Integrasjonskalender",
      "event_integration_calendar": "hendelser Opprettet på en System som du er en del av vil også være Opprettet på denne integrerte kalenderen",
      "2way_sync": "2-Way Synkronisering: Skape System hendelser Fra hendelser booket i den integrerte PRIMÆR-kalenderen",
      "calendars": "Kalendere",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Hake for konflikter",
      "choose_accounts_to_connect": "Velg hvilken Konto Du ønsker å koble til",
      "payments": "Betalinger",
      "stripe": "Stripe",
      "ads": "Reklame",
      "local_service_ads": "Lokal tjenestereklame",
      "fire_workflow": "Fire Arbeidsflyt Triggere for hendelser booket Via 2-veis Synkronisering",
      "connect_google_outlook": "Koble til Google/Outlook/iCloud -kontoen din for å kunne velge PRIMÆR-kalender.",
      "execute_automation": "Gjennomfør automatisering",
      "save": "Arkivere",
      "lsa": "Lokal tjenestereklame",
      "no_write_access": "Du ikke skriv Tilgang i denne kalenderen",
      "connection_remove_confirmation": "Du're Om to Ekstrahere denne integreringen",
      "active": "Aktiv",
      "icloud": {
        "title": "iCloud Integrering",
        "description": "To-faktorautentisering og et app-spesifikt password er obligatoriske for å koble til kontoen din.",
        "email": "iCloud e-postadresse",
        "password": "iCloud-passord",
        "connect": "Koble til",
        "cancel": "Kansellere"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Velge en Kontakt",
    "start_time": "Startdato",
    "unassigned": "Ikke tilordnet",
    "end_time": "Slutt Dato",
    "search_by_name_email_phone_or_company": "Søke Via navn, E-post, Telefon Eller Bedrift",
    "add_new": "Legge til ny",
    "pick_from_available_contacts": "Eller Velge Fra tilgjengelig Venner",
    "book_appointment": "Booke Avtale",
    "add_blocked_off_time": "Legge til Blocked Deaktivert Dato",
    "recommended_timezones": "Anbefalt tidssoner",
    "all_timezones": "hver eneste Timezones",
    "calendar": "Kalender",
    "repeat": "Gjentakelse",
    "date_and_time": "Dato og Dato",
    "close": "Lukke",
    "team_member": "Gruppe Medlemmer",
    "recurring_booking": "Gjentakende bestilling",
    "one_slot_booking": "En tidsluke Booking",
    "event_type": "Hendelsestype",
    "occurrences_booked": "hendelser vil bli booket",
    "repeats": "Gjentakelser",
    "booking_details": "Detaljer",
    "showing_slots_in_this_timezone": "Visning-tidsrom in denne tidssonen:",
    "update_contact_tz": "Oppdater også tidssone for Kontakt til",
    "date": "Dato",
    "slot": "tidsluke",
    "calendar_default": "Standard",
    "custom": "Tilpasset",
    "meeting_notes": "(f.eks.) Konferanse-notater for vår kommende Avtale",
    "out_of_office": "(f.eks.) Fra office for the Uke!",
    "standard": "Standard",
    "appointment_title": "Tittel på Avtale",
    "event_title": "Tittel på Hendelse",
    "appt_with_bob": "(f.eks.) Avtale med Bob",
    "vacation": "(f.eks.) Ferie",
    "show_notes": "Vise notater",
    "hide_notes": "Skjul notater",
    "additional_preferences": "Ytterligere Innstillinger",
    "meeting_location": "Konferanse Sted",
    "appointment_status": "Status for Avtale",
    "appt_description": "Beskrivelse av Avtale",
    "recurring_details": "Gjentakende Detaljer",
    "event_description": "Beskrivelse av Hendelse",
    "in_contact_timezone": "in Kontakts tidssone",
    "vacation_message": "Skal du på ferie? Tar du dato-deaktivert? Blokker deaktivert Dato i kalenderen din for å forhindre Kunder Fra booking Avtale Nåværende Avtale forblir i kalenderen din).",
    "contact": "Kontakt",
    "delete": "Slett",
    "cancel": "Kansellere",
    "back": "Tilbake",
    "pick_available_contacts": "Eller Velge Fra tilgjengelig Venner",
    "no_contacts_found": "Ingen Venner funnet",
    "found": "funnet",
    "select_one": "Velge en",
    "tz_tooltip": "Dette er kun viktig Hvis Du're Via Egendefinerte verdier; som Avtale Avtale Avtale osv. in din Utgående Kommunikasjon med din Kunder Eller Kunder. Og det den gjør, er ganske enkelt å konvertere de ovennevnte detaljene til deres lokale dato.",
    "meeting_location_tooltip": "Konferanse Sted vil være samling som konfigurert in kalenderen.",
    "appt_meeting_location_tooltip": "Brukeren kan Samling the Konferanse Sted spesifikt for Avtale.",
    "gmeet_tooltip": "Sørg for at det aktuelle teammedlemmet har en Google-kalender angitt som deres hovedkalender.",
    "zoom_tooltip": "Sørg for at det aktuelle teammedlemmet har Zoom integrert.",
    "enter_meeting_location": "Angi møtested",
    "save_appointment": "Arkivere Avtale",
    "save_event": "Arkivere Hendelse",
    "search_contacts": "Søke Via navn, E-post, Telefon Eller Bedrift",
    "recurring_slots": "{recurringSlotsLength}{count}",
    "custom_timezone": "Tilpasset tidssone",
    "system_timezone": "System tidssone",
    "contact_timezone": "Kontakt tidssone",
    "account_timezone": "Tidssone for Konto",
    "an_error_occurred": "Det oppsto en feil"
  },
  "popup": {
    "calendar": "Kalender",
    "appointment_owner": "Avtale Eier",
    "source": "Kilde",
    "booked_by": "Booket Via",
    "view_activity_log": "Se Aktivitetslogg",
    "status": "Status",
    "cancel_appointment": "Kansellere Avtale",
    "cancel_all": "Kansellere hver eneste",
    "google_event": "Google-hendelse",
    "outlook_event": "Outlook-hendelse",
    "blocked_slot": "Blokkert tidsluke",
    "appointment": "Avtale",
    "confirmed": "Bekreftet",
    "unconfirmed": "Ubekreftet",
    "cancelled": "Avlyst",
    "showed": "Møtte opp",
    "no_show": "Ikke møtt",
    "invalid": "Ugyldig",
    "more": "Mer",
    "less": "Mindre",
    "edit": "Redigere",
    "reschedule_all": "Planlegge på nytt hver eneste",
    "guests": "Gjest(er)",
    "guest_count": "Antall Gjest(er)."
  },
  "create_calendar": {
    "calendar_name": "Kalendernavn",
    "calendar_logo": "Logo",
    "select_team_member": "Velge Gruppe Medlemmer",
    "select_single_team_member": "Velg gruppemedlem",
    "eg_outbound_reach": "(f.eks.) Utgående rekkevidde",
    "description": "Beskrivelse",
    "amount": "Beløp",
    "description_placeholder": "Skriv beskrivelse",
    "meeting_duration": "Konferanse Varighet",
    "meeting_location": "Møtested",
    "seats_per_class": "Seter per klasse",
    "group": "Gruppe",
    "custom_url": "Tilpasset URL",
    "meeting_invite_title": "Konferanse invitere Tittel",
    "event_color": "Hendelse Farge",
    "availability_type": "Tilgjengelighet Type",
    "new_calendar": "Ny kalender",
    "add_description": "Legg til beskrivelse",
    "remove_description": "Ekstrahere Beskrivelse",
    "booking_availability": "Tilgjengelighet for bestilling",
    "slug_tooltip": "Tilpass URL-en til bestillingswidgeten.",
    "meeting_location_tooltip": "Konferanse Links er Møtte opp in kalenderhendelser som «Konferanse Sted» og Aktivere Du to Inkludere things Like zoom-lenker for Hendelsen.",
    "advanced_settings": "Avanserte innstillinger",
    "show_more_schedule": "Vis mer",
    "show_more_helper_text": "Hvis du vil tilpasse åpningstidene ytterligere, kan du gå til de avanserte innstillingene.",
    "reschedule_preference": "Preferanse for ombooking",
    "reschedule_preference_subtext": "Hvis en {contactLabel} endrer en avtale:",
    "reassign_through_round_robin": "Omtilordne Via Rotasjonsordning",
    "keep_same_assinged_user": "Se den samme Avtale Eier",
    "new_appointment_preference": "Preferanse for ny avtale",
    "new_appointment_preference_text": "Bestill alltid med den tildelte brukeren til {contactLabel}.",
    "new_appointment_preference_subtext": "Lag nye avtaler med den {contactLabel}-tilordnede brukeren i stedet for å bruke rotasjonsordning.",
    "cancel": "Kansellere",
    "confirm": "Bekreft",
    "service_calendar_name": "Tjenestenavn",
    "service_logo": "Logo",
    "service_select_team_member": "Velg medarbeider",
    "service_duration": "Tjeneste Varighet",
    "appointment_invite_title": "Tittel på Avtale",
    "payment_placeholder": "Skriv inn en beskrivelse som vil bli vist til brukeren, og informer dem om betalingen",
    "deposit_amount": "Depositumsbeløp",
    "collect_deposit_amount": "Godta Ufullstendig betaling",
    "percentage": "Prosentdel",
    "total_amount": "Totalbeløp",
    "enter_meeting_location": "Angi møtested",
    "accept_payments": "Godta betalinger",
    "aria": {
      "should_accept_payment": "Burde godta utbetaling"
    },
    "calendar_name_tooltip": "Kalendernavnet som skal vises på bestillingswidgeten.",
    "booking_availability_tooltip": "Angi dagene og klokkeslettene når bestillinger kan gjøres. Dette er dine standard ukentlige åpningstider som vises til brukere når de velger en tidsluke.",
    "select_team_member_tooltip": "Velg teammedlemmet/-medlemmene som skal ta dette møtet.",
    "seats_per_class_tooltip": "Angi maksimalt antall deltakere som kan bestille denne klassen. Når alle setene er fylt, vil tidsluken ikke lenger være tilgjengelig for bestilling.",
    "meeting_color": "Konferanse Farge",
    "meeting_duration_tooltip": "Dette angir lengden på møtet ditt og bestemmer hvor lenge det vil vare."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Hurtigtips",
      "timezone_change_tip": "Tidssoner kan endres når som helst under tidssoneinnstillinger",
      "save": "Lagre endringer",
      "close": "Lukke",
      "meeting_details": "Grunnleggende detaljer",
      "availability": "Tilgjengelighet",
      "forms_and_payment": "Skjemaer og betaling",
      "notifications_and_additional_options": "Notifikasjoner og flere alternativer",
      "connections": "Tilkoblinger",
      "customizations": "Tilpasninger",
      "create": "Skape",
      "edit": "Redigere",
      "equipments": "Rom og utstyr",
      "service_details": "Detaljer om tjenesten",
      "booking_rules": "Regler for bestilling",
      "advanced_settings": "Avanserte innstillinger",
      "form_and_confirmation": "Skjema og bekreftelse",
      "payments": "Payments",
      "notifications_and_policies": "Notifikasjoner og retningslinjer",
      "widget_appearance": "Widgetens utseende",
      "saving_changes": "Bare et minutt — Lagrer den siste Dynamisk...",
      "calendar_id": "Calendar Id",
      "saveCalendarSuccess": "Kalenderen er lagret",
      "external_sync": "Ekstern synkronisering",
      "booking_channels": "Bestillingskanaler",
      "meeting_location": "Møtested",
      "staff_location": "Ansatte og sted"
    },
    "meeting_details": {
      "meeting_location": "Konferanse Sted",
      "meeting_location_label": "Møtested",
      "enter_meeting_location": "Gå inn på Konferanse Sted",
      "click_to_upload": "klikk for å siste opp",
      "square": "Firkant",
      "circle": "Sirkel",
      "remove_logo": "Ekstrahere Logo",
      "meeting_invite_title_tooltip": "Dette er tittelen på kalendermøtet som vises i avtalelistevisningen, kalendervisningen og tredjepartskalendere.",
      "event_color_tooltip": "Velge en Farge for denne bestillingen Hendelse. Farger synkroniseres til hendelser in Google Kalender.",
      "enter_a_name": "Angi et navn.",
      "enter_an_event_title": "Skriv inn en tittel for hendelsen.",
      "high_priority": "Høy prioritet",
      "medium_priority": "Middels prioritet",
      "low_priority": "Lav prioritet",
      "priority": "Prioritet",
      "custom": "Tilpasset",
      "zoom_not_added": "Brukeren har ennå ikke koblet til Zoom-kontoen sin.",
      "opt_avail": "Optimaliser for Tilgjengelighet",
      "opt_equal": "Optimaliser for lik Leveranse",
      "team_members": "Velge Gruppe Medlemmer",
      "team_members_location": "Velg ansatte og tilordne møtested",
      "team_member": "Velg teammedlem",
      "team_member_location": "Velg ansatte og tilordne møtested",
      "meeting_location_required": "Møtested er påkrevd.",
      "meeting_details": "Grunnleggende detaljer",
      "meeting_details_description": "Grunnleggende informasjon som brukes til å identifisere denne kalenderen.",
      "or_drag_and_drop": "Eller Dra og slipp",
      "service_details": "Detaljer om tjenesten",
      "team_member_disabled_recurring_tooltip": "Gjentakende møter Aktivere kun én Gruppe Medlemmer. For å inkludere flere Gruppemedlemmer, vennligst deaktiver Gjentakende møter.",
      "team_member_disabled_class_booking_tooltip": "Bare ett teammedlem kan legges til i en kalender for klassebestilling.",
      "advanced_settings": "Avanserte innstillinger",
      "enable_contact_assigned_to_setting": "For å aktivere denne innstillingen, må Skjema være først in Widget -sorteringen. Vennligst Planlegge på nytt the Widget Sortere fra fanen Skjema og betaling.",
      "reschedule_preference_setting_tooltip": "Velg hvem avtalen skal tilordnes når en {contactLabel} endrer avtalen fra bestillingswidgeten.",
      "appointment_preference_tooltip": "Velg om nye avtaler alltid skal bestilles med {contactLabel}s tildelte bruker. Hvis en {contactLabel} har en tilordnet bruker, vil den brukeren bli prioritert. Ellers vil det være en rotasjonsordning. Tips: Slå av «Tillat valg av ansatte» for å hindre at bookere endrer ansattmedlemmet i avtale-widgeten.",
      "add_location": "Legg til sted",
      "multiple_locations_neo": "Tilby flere stedsalternativer som bestilleren kan velge mellom. Flere steder støttes kun av Neo Widget.",
      "make_owner": "Skape Eier",
      "only_one_team_member": "Kun én Gruppe-medlem er tillatt når flere adresser er lagt til.",
      "ask_the_booker_error_message": "Spør bestilleren om stedet allerede eksisterer.",
      "enter_location": "Angi stedsverdi",
      "enter_display_label": "Skriv inn visningsetikett",
      "add_display_label": "Legg til visningsetikett",
      "multiple_location_support_message": "Tilby flere stedsalternativer som bestilleren kan velge mellom. Flere steder støttes kun av Neo Widget.",
      "only_one_team_member_personal_calendar": "Kun ett teammedlem er tillatt for personlig booking. ",
      "ms_teams_not_added": "Brukeren har ikke koblet Microsoft Teams-kontoen sin ennå.",
      "enable_new_appt_preference": "Aktivere ny Avtale Preferanse",
      "enable_new_appt_preference_desc": "Hvis du aktiverer « <b>Bestill alltid med den tilordnede brukeren til {contactLabel}</b>», settes <b>skjemaet</b> automatisk som det første trinnet i widget-rekkefølgen.",
      "location_exists_toast": "Konferanse Sted allerede lagt til",
      "not_supported_with_multiple_team_members": "Støttes ikke av Multiple Gruppe Medlemmer",
      "not_supported_personal_calendar": "Støttes ikke in personlig kalender",
      "not_supported_class_booking": "Støttes ikke in Klasse Tjenestekalender",
      "not_supported_collective_booking": "Støttes ikke in KOLLEKTIV-kalenderen",
      "not_supported_service_booking": "Støttes ikke in Tjenestekalender",
      "not_supported_round_robin": "Støttes ikke in Rotasjonsordning-kalenderen",
      "not_supported_event": "Støttes ikke in Hendelse-kalenderen",
      "calendar_logo_tooltip": "Velg en logo som skal vises på bestillingswidgeten.",
      "calendar_name_tooltip": "Kalendernavnet som skal vises på bestillingswidgeten.",
      "description_tooltip": "Beskriv hva kalenderen handler om, som skal vises i bestillingswidgeten.",
      "group_tooltip": "Du kan tilordne denne kalenderen til en gruppe (hvis den er opprettet). Brukere som får tilgang til gruppelenken kan bla gjennom og bestille fra alle kalendere i den gruppen.",
      "custom_url_tooltip": "Tilpass URL-en til bestillingswidgeten.",
      "meeting_color_tooltip": "Velg en farge for denne bestillingshendelsen. Farger blir synkronisert med hendelser i Google-kalendere.",
      "add_display_label_tooltip": "Skjul det faktiske stedet og vis en tilpasset etikett inntil møtet er booket (gjelder når flere steder legges til).",
      "meeting_location_tooltip": "Velg et sted, eller velg Egendefinert for å legge til en hvilken som helst adresse eller møtelenke.",
      "team_members_location_tooltip": "Velg den ansatte som skal ta dette møtet og angi møtestedet.",
      "meeting_distribution": "Møtedistribusjon",
      "meeting_distribution_tooltip": "Velg hvordan møter tilordnes til ansatte.",
      "opt_avail_tooltip": "Tilordne møter til den ansatte som er tilgjengelig på det valgte tidspunktet, uavhengig av tidligere reservasjoner. Maksimerer utnyttelsen av ledige tidsluker og suksessrater for booking.",
      "opt_equal_tooltip": "Fordel møtene jevnt blant alle ansatte ved å spore tidligere bestillinger. Prioriterer rettferdighet fremfor tilgjengelighet.",
      "priority_tooltip": "Angi preferansenivået for tildeling av møter når flere medarbeidere er tilgjengelige. Ansatte med høy prioritet vil bli vurdert først for bestillinger, etterfulgt av ansatte med middels og lav prioritet.",
      "contact_routing_preference": "Kontakt Preferanse for Kontakt",
      "contact_routing_preference_tooltip": "Definer hvordan nye og returnerede {contactsLabel} skal tildeles ansatte – enten ved rotasjonsordning eller den opprinnelige eieren.",
      "team_members_location_owner_tooltip": "Hovedbrukeren som eier møtet og angir det endelige møtestedet.",
      "owner": "Eier",
      "upload_from_system": "Last opp fra system",
      "choose_from_media_storage": "Velg fra lagret media",
      "only_one_team_member_allowed": "Kun én teammedlem er tillatt.",
      "at_least_two_team_members_required": "Minst to teammedlemmer er påkrevd.",
      "at_least_one_team_member_required": "Minst ett teammedlem er påkrevd.",
      "widget_shape": "Widget-form:",
      "widget_bookings_path": "/widget/bookings/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "profilbilde",
      "meeting_location_placeholder": "Møtested",
      "team_member_meeting_location": "Ansatte og møtested",
      "meeting_location_desc": "Tilordne ansatte til denne kalenderen og angi hvor møtene skal ta sted.",
      "event_calendar_meeting_location_desc": "Velg hvor møtet skal ta sted."
    },
    "meeting_location": {
      "ask_the_booker": "Spør bestilleren (bestilleren angir stedet)",
      "ask_the_booker_desc": "Bestilleren blir bedt om å angi et valgfritt møtested ved bestilling",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Telefon",
      "full_address": "Full adresse",
      "custom": "Tilpasset",
      "meeting_location": "Møtested"
    },
    "availability": {
      "my_availability": "Min Tilgjengelighet",
      "calendar_availability": "Kalendertilgjengelighet",
      "calendar_availability_desc": "Angi når møter kan bookes i denne kalenderen.",
      "set_availability": "Samling din Tilgjengelighet for kalenderen her.",
      "standard": "Standard",
      "custom": "Tilpasset",
      "to": "Til",
      "copy_to_all": "Kopiere til hver eneste",
      "add_time": "Legge til Dato",
      "recurring_meeting": "Gjentakende Konferanse",
      "recurring_info": "Kun én bruker per kalender for gjentakende bestilling.",
      "repeat": "Gjentakelse",
      "times_to_repeat": "ganger til Gjentakelse",
      "slots_unavailable": "Hvis tidsluker er utilgjengelige?",
      "overlap_status": "Avtale Status for overlappende tidsluker ",
      "meeting_interval": "Møteintervall",
      "meeting_duration": "Konferanse Varighet",
      "minimum_scheduling": "Min.. Planlegge MERKNAD",
      "date_range": "Dato Omfang",
      "maximum_bookings_per_day": "Gjør bestillinger per dag",
      "maximum_bookings_per_slot": "Maks antall bestillinger per tidsluke",
      "maximum_bookings_per_slot_per_user": "Foretar bestillinger per tidsluke (per Bruker)",
      "seats_per_class": "Seter per klasse",
      "pre_buffer_time": "Pre BUFFER Dato",
      "post_buffer_time": "Slett BUFFER Dato",
      "pre_buffer_tooltip": "Buffer-tid før avtale er ekstra tid som kan legges til før en avtale, slik at man får ekstra tid til å gjøre seg klar.",
      "post_buffer_tooltip": "Buffer-tid etter avtale er ekstra tid som kan legges til etter en avtale, slik at man får ekstra tid til å avslutte.",
      "buffer_time": "BUFFER Dato",
      "daily": "Daglig",
      "weekly": "Ukentlig",
      "monthly": "Månedlig",
      "skip_booking": "Hopp over booking av utilgjengelige tidsrom",
      "continue_booking": "Fortsette å bestille",
      "book_next_available": "Booke Neste tilgjengelig tidsluke",
      "confirmed": "Bekreftet",
      "unconfirmed": "Ubekreftet",
      "enter_valid_hours": "Vennligst oppgi gyldig Åpne-tid",
      "enter_valid_avail": "Vennligst oppgi gyldig Tilpasset Tilgjengelighet",
      "availability_type_tooltip": "Velge Standard Tilgjengelighet for månedlige bestillinger som tilbys Ukentlig. Velge Tilpasset for bestillinger kun tilgjengelig på spesifikke datoer.",
      "meeting_interval_tooltip": "Kontrollerer hvor ofte bestillingstidsluker vises.\nFor et 30-minutters møte: \n• Velg 1 time for å vise tidsluker øverst i hver time. \n• Velg 30 minutter for å vise tidsluker hvert 30. minutt.",
      "date_range_tooltip": "hendelser kan planlegges i løpet av de neste n dagene.",
      "maximum_bookings_per_day_tooltip": "Maksimalt antall møter tillatt per dag i denne kalenderen.",
      "maximum_bookings_per_slot_tooltip": "Begrens hvor mange møter en bruker kan ha i samme tidsluke. Hvis grensen er nådd, blir bookingen tildelt neste bruker i køen, eller tidsluken blir utilgjengelig.",
      "add_days": "Legge til dager",
      "month_on_day": "Månedlig På Dag",
      "month_on_last_day": "Månedlig På sist",
      "day": "Dag",
      "week": "Uke",
      "month": "Måned",
      "mins": "Minutter",
      "hours": "Timer",
      "days": "Dager",
      "weeks": "Uker",
      "months": "Måneder",
      "meeting_interval_error": "Møteintervall må være på mellom 5 minutter og 12 timer.",
      "meeting_duration_error": "Møtevarighet må være mellom 1 minutt og 12 timer.",
      "buffer_time_error": "Buffer må være mindre enn 12 timer.",
      "appointment_interval": "Avtale Søker",
      "appointment_duration": "Avtale Varighet",
      "maximum_appointments_per_day": "Maks Avtale per dag",
      "subTitle": "Velg dato for å angi spesifikke timer.",
      "heading_1": "Ukentlige tilgjengelige timer",
      "scheduling_availability_heading": "Bestillingstilgjengelighet",
      "scheduling_availability_tooltip": "Bruk en eksisterende plan eller opprett en egendefinert plan for denne kalenderen.",
      "tooltip_1": "Sett opp en ukentlig tilgjengelighetsplan. Dette er standardtimene dine som vil bli brukt konsekvent på ukentlig basis.",
      "heading_2": "Når er du tilgjengelig?",
      "unavailable_label": "Utilgjengelig",
      "tooltip_2": "Endre planen din for spesifikke datoer. Overstyr din Månedlig Ukentlig tid Via markering Tilgjengelighet Eller utilgjengelighet for Valgt datoer.",
      "date_specific_level": "Legge til Dato-spesifikk tid",
      "specific_hours_button": "Datospesifikke timer",
      "specific_hours_description": "Overstyr ledig tid for bestemte datoer når timene dine avviker fra de vanlige ukentlige timene.",
      "overlap_error": "Tidsluker kan ikke overlappe hverandre.",
      "apply": "Iverksette",
      "copy_times_to": "Kopiere ganger til",
      "no_date_specific_heading": "Ingen datospesifikk tid lagt til.",
      "no_date_specific_description": "Du kan legge til/fjerne spesifikke datoer og klokkeslett i tilgjengeligheten din.",
      "recurring_disabled_conditions_tooltip": "Gjentakende møter er deaktiverte. For å trigger dem, sørg for at kalenderen kun har én Gruppe Medlemmer og ikke har datospesifikk klokkeslett Eller Ufullstendig betaling lagt til.",
      "date_specific_hours_disabled_conditions_tooltip": "For å inkludere et datospesifikk klokkeslett, vennligst sørg for at Gjentakende møter er deaktivert.",
      "recurring_disable_event_calendar_conditions": "Gjentakende møter er deaktiverte. For å trigger dem, sørg for at ingen datospesifikk tid Eller Ufullstendig betaling lagt til.",
      "service_duration": "Tjeneste Varighet",
      "service_interval": "Tjenestesøker",
      "service_interval_tooltip": "Konferanse Sekunder Satt hvor ofte vises bookingautomater i kalenderen. For modell, i 30 minutter, betyr en 1-gangers kunder at tidsluker vises hver eneste tid. En 30-minutters uke betyr at tidsluker vises hver eneste 30. minutt.",
      "service_duration_tooltip": "Denne Satt the Lengde av Avtale din, avgjør hvor lenge den vil vare.",
      "minimum_scheduling_tooltip": "Dette Satt the Min.. Dato Obligatorisk to Booke a Avtale Via Widget. For Modell, Hvis Samling til 4 ganger, kan ikke Avtale bestilles innen 4 ganger av startdatoen; Bestillinger må gjøres minst fire ganger in forveien.",
      "look_busy_title": "Se opptatt ut",
      "look_busy_helper_text": "Skjul en Prosentdel av dine tilgjengelige Avtale-automater På Bestillingswidgeten for å se travlere og in .",
      "look_busy_percentage_description": "Skjul antall tilgjengelige tidsluker med x%.",
      "maximum_bookings_per_slot_tooltip_personal": "Maksimalt antall møter tillatt i en enkelt tidsluke.",
      "enable_recurring_title": "Aktiver gjentakende møte",
      "enable_recurring_desc": "Når du slår på <b>Gjentakende møter</b> deaktiveres automatisk følgende innstillinger, da de ikke kan eksistere samtidig:",
      "date_specific_hours": "Alle <b>dato-spesifikke tider</b> vil bli slettet.",
      "multiple_team_members": "<b>Flere teammedlemmer</b> vil bli fjernet – bare ett teammedlem kan bli værende i denne kalenderen.",
      "partial_payments": "<b>Ufullstendig betalinger</b> vil være deaktivert, og Full beløpet vil bli innkrevd.",
      "select_team_member_to_keep": "Velge en gruppemedlemmer å se in denne kalenderen:",
      "select_team_member": "Velg teammedlem",
      "partial_payments_disabled": "Siden delbetalinger vil bli deaktivert, hvordan ønsker du å kreve inn hele beløpet for gjentakende avtaler?",
      "enable_date_specific_hours": "Aktiver datospesifikke åpningstider",
      "enable_date_specific_hours_desc": "Hvis du slår på <b>Datospesifikke tider</b>, deaktiveres følgende innstilling automatisk, ettersom de ikke kan eksistere samtidig:",
      "recurring_meetings_disabled": "<b>Gjentakende møter vil bli deaktivert</b>, {contactsLabel} vil bare kunne booke enkeltavtaler basert på de tilgjengelige datoene du angir.",
      "payment_preference": "Betalingspreferanse:",
      "team_members_in_this_calendar": "Teammedlemmer i denne kalenderen",
      "other_team_members": "Andre teammedlemmer (ikke lagt til i denne kalenderen)",
      "select_team_member_tooltip": "Velg teammedlemmet/-medlemmene som skal ta dette møtet.",
      "meeting_duration_tooltip": "Dette angir lengden på møtet ditt og bestemmer hvor lenge det vil vare.",
      "date_specific_hours_tooltip": "Endre planen din for spesifikke datoer. Overstyr de vanlige ukentlige timene dine ved å markere tilgjengelighet eller utilgjengelighet for utvalgte datoer.",
      "recurring_meeting_tooltip": "Tillat at møter gjentas flere ganger i løpet av en tidsperiode.",
      "repeat_frequency_tooltip": "Velg hyppigheten for denne gjentakende hendelsen.",
      "time_to_repeat_tooltip": "Angi totalt antall gjentakelser.",
      "slots_unavailable_tooltip": "Velg hva som skal skje hvis én eller flere tidsluker i en gjentakende bestilling allerede er booket.",
      "skip_booking_tooltip": "Kun de tilgjengelige tidslukene vil bli booket. Eventuelle utilgjengelige datoer i den gjentakende serien vil bli hoppet over.",
      "force_book": "Force Booke",
      "force_booking_tooltip": "Alle tidsluker vil bli booket, selv om det oppstår en konflikt. Bruk forsiktig for å unngå dobbeltbooking.",
      "book_next_available_tooltip": "Hvis en valgt tidsluke ikke er tilgjengelig, bestilles neste ledige tidsluke på samme gjentakende plan (f.eks. neste mandag hvis det er ukentlig).",
      "slot_interval_tooltip": "Angi tidsintervallet mellom starttidene for påfølgende ledige tidsluker. For eksempel, hvis møtevarigheten er 30 minutter og du setter intervallet til 60 minutter, kan en bruker bestille klokken 09:00, deretter klokken 10:00 og så videre – selv om hvert møte bare varer i 30 minutter.",
      "minimum_scheduling_notice_tooltip": "Krev at brukerne bestiller møter minst så lang tid i forveien.",
      "date_range_preferences_tooltip": "Angi hvor langt frem i tid bestillinger kan gjøres fra dagens dato.",
      "maximum_bookings_per_slot_preferences_tooltip": "Begrens hvor mange møter som kan settes opp for samme tidsluke.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Begrens hvor mange møter som kan planlegges for samme tidsluke (per bruker).",
      "pre_buffer_time_tooltip": "Tid som blokkeres før hvert møte, slik at det er ekstra tid til forberedelser.",
      "post_buffer_time_tooltip": "Tid som blokkeres etter hvert møte, slik at det er ekstra tid til å avslutte.",
      "seats_per_class_tooltip": "Angi maksimalt antall deltakere som kan bestille denne klassen. Når alle setene er fylt, vil tidsluken ikke lenger være tilgjengelig for bestilling.",
      "maximum_bookings_per_slot_per_user_tooltip": "Begrens hvor mange møter som kan planlegges for samme tidsluke (per bruker).",
      "repeat_frequency": "Gjentakelsesfrekvens",
      "slot_interval": "Tidslukeintervall",
      "skip_booking_helper_text": "Kun de tilgjengelige tidslukene vil bli booket. Eventuelle utilgjengelige datoer i den gjentakende serien vil bli hoppet over.",
      "force_book_helper_text": "Alle tidsluker vil bli booket, selv om det oppstår en konflikt. Bruk forsiktig for å unngå dobbeltbooking.",
      "book_next_available_helper_text": "Hvis en Valgt tidsluke er utilgjengelig, booke den neste tilgjengelige tidsluken på samme Gjentakende plan (f.eks. Neste Mandag Hvis Ukentlig).",
      "bulk_edit": "Bulkredigering",
      "select_users": "Velg brukere",
      "select_all": "Velg alle",
      "times_to_repeat_tooltip": "Angi totalt antall gjentakelser.",
      "custom_recurrence": "Egendefinert gjentakelse",
      "repeats_every": "Gjentas hver",
      "availability_schedule": "Tilgjengelighetsplan",
      "availability_schedule_desc": "Angi når møter kan bookes basert på de ansattes tilgjengelighet.",
      "no_users_added": "Ingen ansatte lagt til!",
      "no_users_added_description": "Legg til ansatte for å sjekke om de er tilgjengelige",
      "add_users": "Legg til ansatte",
      "minimum_scheduling_notice_error": "Skriv inn ≤ 1440 minutter.",
      "please_select_date": "Velg en dato for å fortsette"
    },
    "forms_payment": {
      "forms": "Skjemaer og gjester",
      "forms_sub": "Konfigurer preferanser for den siste siden som vises etter en vellykket bestilling.",
      "select_form": "Velge Skjema",
      "enable_same_user_assignment": "Tildel kontakter til de respektive kalender-teammedlemmene hver gang en avtale bookes.",
      "sticky_contacts_label": "Sticky {contactsLabel}",
      "sticky_contacts": "Pre-populate fields",
      "confirmation_page": "Bekreftelsesside",
      "default": "Standard",
      "redirect_url": "Omdirigerings-URL",
      "thank_you": "Takk, Du Melding",
      "enter_url": "Skriv inn URL",
      "enter_thank_you_message": "Skriv inn en takkemelding.",
      "amount_tab_hidden_label": "Plassholder for mengdefane",
      "percentage_tab_hidden_label": "Plassholder for prosentfane",
      "pixel_id": "Meta Pixel-Id (Valgfritt)",
      "auto_confirm": "Bekreft ny kalendermøter automatisk",
      "configure_payment": "Konfigurere betalingsalternativer",
      "accept_payments": "Godta betalinger",
      "test": "Test",
      "live": "Direkte",
      "enable_guests": "Legg til gjester",
      "add_guest_tooltip": "Legg til gjest lar deltakeren legge til flere deltakere i samme avtale.",
      "add_guest_custom_form_tooltip": "Hvis du aktiverer dette alternativet, sendes en systemgenerert e-post til gjestene med en lenke til det tilpassede skjemaet, når avtalen deres er bekreftet. For å forhindre dupliserte e-poster, sørg for at det ikke allerede er satt opp en egen bekreftelses-e-post for gjester. (Bekreft dette i Notifikasjoner-fanen > Bekreftelsesnotifikasjon).",
      "add_guest_same_form_check": "Send det samme skjemaet for å samle inn informasjon via e-post til alle gjester.",
      "payment_tooltip": "Betaling vil kun bli vurdert for PRIMÆR Gjest og ikke for gjestene.",
      "default_form": "Standard (fornavn, søsternavn, e-post, telefon, notater)",
      "select_form_tooltip": "Hvis Du Like å samle inn flere detaljer enn Standard fornavn, siste navn, e-post og telefon Fra de som booker på denne kalenderen, Skape a Tilpasset Skjema in Nettsteder > Skjemaer > Bygger Neste Velge the Skjema Via Rullegardinmeny under.",
      "confirmation_page_tooltip": "Når noen har foretatt en bestilling, kan du velge å vise dem en Tilpasset Melding på samme side (Standard) Eller omdirigere dem til en side etter eget valg (omdirigering).",
      "add_guest_collect_email": "Navn og e-post",
      "add_guest_count_only": "Antall telle",
      "custom_email_notification": "Send tilpasset skjema til gjester.",
      "consent_label": "Tillatelse Avmerkingsboks",
      "consent_input_placeholder": "Legg til samtykketekst",
      "same_user_assignment_tooltip": "For å aktivere denne innstillingen, må Skjema være først på Widget. Planlegge på nytt Widget for å Status Skjema som den første som trigger denne Innstillingen.",
      "consent_tooltip": "Be kontakter om å gi tillatelse når de bestiller et møte.",
      "stripe_error": "Opptil to desimaler (modell: 25,99)",
      "auto_confirm_service": "Automatisk bekreft ny Avtale",
      "service_form_message": "Hvis en kontakt bestiller flere tjenester, vil de kun se standardskjemaet i tjenestemenyen.",
      "deposit_amount_error": "Innskuddsbeløpet må være mindre enn Total .",
      "deposit_percentage_error": "Prosentdel for innskudd må være mindre enn 100 %.",
      "partial_payment_tooltip": "Aktivere Ufullstendig betalinger for å kreve inn depositum Fra Kunder under Avtale-bestillingen Arbeidsflyt.",
      "partial_payment_enable_error": "Total som legges inn må være større enn 0 for å aktivere Aktivere Ufullstendig-betalinger.",
      "payment_disable_text_integration": "Integrer en betalingsleverandør under Betalinger > Integrasjoner for å begynne å godta betalinger",
      "payment_disable_text_recurring": "Godta betalingsmåten er utilgjengelig for Gjentakende-møter. Deaktiver Gjentakende til Aktivere betalinger.",
      "date_and_time_selector": "Dato- og tidsvelger",
      "form_selector": "Skjema",
      "order_step": "Skritt",
      "widget_order_label": "Widget -sortering",
      "widget_order_tool_tip": "Endre rekkefølgen på \"Dato- og tidsvelger\" og \"Skjema\" på kalenderwidgeten. Dra og endre rekkefølgen etter eget ønske.",
      "widget_re_order_tooltip": "Ombestilling er bare tilgjengelig med Neo Widget stilen. Bytt til Neo til Aktivere ombestilling.",
      "widget_re_order_disabled_tooltip": "For å endre rekkefølgen på widgetene, deaktiver «Ny avtalepreferanse (bestill alltid med den tildelte brukeren til {contactLabel})» fra Møtedetaljer > Teammedlemmer > Avanserte innstillinger.",
      "payment_description_error": "Maksimal tegngrense på 1000 er nådd.",
      "widget_multiple_location_disabled_tooltip": "Den klassiske widgeten støtter ikke flere møtesteder. Fjern eventuelle ekstra steder for å bruke den klassiske widgeten.",
      "recurring_payment_label": "Gjentakende Avtale betaling",
      "enable_payments_for_guests": "Aktiver betalinger for gjester",
      "guest_payment_description": "Siden Du've aktiverer «Legge til gjestene»-alternativet, kan du også velge å pris per Gjest når av bookingen.",
      "charge_per_attendee": "Kostnad per deltaker",
      "charge_per_attendee_description": "Multiplisere Total Via de høye av deltakere (inkludert gjester) når de henter inn betalingen under bestilling.",
      "click_confirm_description": "Klikk på lagre for å iverksette disse endringene.",
      "multiply_amount_guests": "Samle betaling for hver eneste deltakere",
      "multiply_amount_guests_description": "Når denne funksjonen er aktivert, multipliseres beløpet som skal innkreves under bestillingen, med det totale antallet deltakere, inkludert gjester.",
      "first_appointment_only": "pris kun for første Avtale",
      "all_appointments": "pris for hver eneste Avtale på forhånd",
      "no_payment_provider_connected": "Ingen betalingsleverandør er tilkoblet.",
      "no_default_payment_provider": "Ingen betalingsleverandør tilkoblet",
      "provider_not_supported": "Standard Leverandør støttes ikke",
      "manage_payment_provider": "Administrer betalingsleverandører",
      "supported_providers": "Støttede leverandører:",
      "paypal_razorpay_helper_text": "Betalinger behandles kun gjennom Razorpay, ettersom PayPal ikke støttes med egendefinerte leverandører.",
      "rearrange_widget_order": "Endre rekkefølgen på widgeter",
      "change_form_order": "Dynamisk Skjema til andre Sritt in Widget Sortere vil deaktivere Etterfølgende Innstilling:",
      "change_form_order_desc": "<b>Ny avtalepreferanse (alltid bestill med {contactLabel}s tildelte bruker)</b> vil bli deaktivert. Dette betyr at avtaler kan lages med et hvilket som helst tilgjengelig teammedlem, i stedet for å være begrenset til {contactLabel}s tildelte bruker.",
      "enable_mandatory_guest": "Skape legger til minst én Gjest Obligatorisk. Gjest Felter vil være forhåndsåpnet og må fylles før booking.",
      "enable_mandatory_guest_count": "Registrer obligatorisk antall gjester i bestillingswidgeten.",
      "require_guest_for_booking": "Krev at gjester registrerer seg for bestilling",
      "sticky_contacts_tooltip": "Automatisk utfylling av felt for kjente {contactsLabel}.",
      "auto_confirm_tooltip": "Merk nye møter automatisk som bekreftet uten å kreve manuell godkjenning. Deaktiver dette hvis du vil vurdere og bekrefte hver bestilling manuelt før den blir planlagt.",
      "confirm_tooltip": "Når noen gjør en bestilling, kan du velge å vise dem en tilpasset melding på samme side (Standard) eller omdirigere dem til en side du velger (Omdirigerings-URL).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Aktiver innsamling av betaling under bestillinger.",
      "total_amount_tooltip": "Angi det totale gebyret for møtet.",
      "deposit_amount_tooltip": "Beløp som skal innkreves ved bestilling som et depositum.",
      "multiply_amount_guests_all_guests": "Innkreve betaling for hver eneste deltakere, inkludert gjester",
      "multiply_amount_guests_all_guests_tooltip": "Når denne funksjonen er aktivert, multipliseres beløpet som skal innkreves under bestillingen, med det totale antallet deltakere, inkludert gjester.",
      "payment_description": "Betalingsbeskrivelse",
      "payment_description_desc": "Vises til bestilleren når betalingsopplysninger legges inn.",
      "payment_description_tooltip": "Du kan legge til eventuelle nyttige detaljer om betalingen.",
      "test_mode_warning": "TestAktiv – ingen ekte Salg vil bli behandlet.",
      "pixel_id_tooltip": "Send aktivitet fra bestillingswidgeten som visninger, klikk og innsendinger til Meta ved hjelp av din Pixel ID.",
      "forms_description": "Set your preferences and settings for collecting customer information during bookings.",
      "payment_mode": "Betalingsmodus",
      "payment_mode_tooltip": "Veksle mellom Testmodus og Direkte-modus for betalinger. in Testmodus foretas det ingen reell fakturering — bruk den til å simulere booking og betaling Arbeidsflyt. Bytt til Direkte-modus for å godta faktiske betalinger Fra Kunder.",
      "enable_coupon": "Aktiver kupongkoder",
      "enable_coupon_tooltip": "Tillat kunder å bruke kupongkoder under bestilling. For å sikre at de fungerer, opprett gyldige kupongkoder først under Betalinger > Kupongkoder.",
      "guests": "Guests"
    },
    "notifications": {
      "third_party_cal": "Innstillinger for tredjepartskalender",
      "third_party_cal_desc": "Konfigurer innstillingene dine for tredjepartskalendere.",
      "additional_settings": "Flere innstillinger",
      "additional_settings_desc": "Konfigurer flere innstillinger for kalenderen din.",
      "notifications": "Notifications",
      "notifications_sub": "Konfigurer hvordan du sender bookingnotifikasjoner via e-post, SMS, WhatsApp og notifikasjoner i appen.",
      "edit": "Rediger",
      "created_on": "Opprettet den",
      "updated_on": "Oppdatert den",
      "delivered": "Sendt",
      "not_available": "Uaktuelt",
      "select_notification_type": "Velg type notifikasjon.",
      "notification_person": "Hvem skal sende denne notifikasjonen?",
      "contact": "{contactLabel}",
      "guest": "Gjest",
      "assigned_user": "Tildelt Bruker",
      "emails": "Gmail",
      "alert_email_address": "E-postadresse for Varsel",
      "ack_email": "Bekreftelse E-post",
      "send_google_invites": "Aktivere Google Kalender for å siste opp invitasjonen eller oppdater Gmail til deltakerne.",
      "assign_user_to_contact_desc": "When enabled, {contactLabel}’s assigned user will match the owner of the appointment with the most recent change — whether it’s been booked, rescheduled, or reassigned.",
      "send_google_outlook_invites": "Tillat Google/Outlook/iCloud-kalenderen å sende invitasjons- og oppdaterings-e-poster til deltakerne.",
      "assign_user_to_contact": "Tildel {contactsLabel} til sine respektive kalenderteammedlemmer hver gang en avtale bestilles.",
      "skip_assigning_user_to_contact": "Hopp over tildelingen av {contactLabel} hvis {contactLabel} allerede har en tilordnet bruker.",
      "skip_assigning_user_to_contact_desc": "When enabled, a {contactLabel}’s assigned user will remain the same, even if the appointment owner is different.",
      "assigned_staff": "Tilordnet personale",
      "additional_emails": "Ytterligere Gmail",
      "assign_user_to_staff": "Tildel alltid kontakt til avtaleeieren.",
      "allow_cancellation": " Tillat avbestilling av møte",
      "allow_reschedule": "Tillat ombooking av møtet",
      "allow_cancellation_tooltip": "Når Aktivert, vil en kansellering Lenke bli lagt til i tilleggsnotat-seksjonen og inkludert in kalenderinvitasjonen. Denne Lenke vil Utløper som konfigurert før Konferansen starter Dato, og forhindrer at Booker Fra kansellerer Konferansen.",
      "allow_reschedule_tooltip": " Når Aktivert, vil en ny planlegging av Lenke bli lagt til i tilleggsnotat-seksjonen og inkludert in kalenderinvitasjonen. Denne Lenke vil Utløper som konfigurert før Konferansen starter Dato, og forhindrer at Booker fra planlegger Konferansen på nytt.",
      "cancellation_link_expiry": "Avbestilling Lenke vil Utløper",
      "reschedule_link_expiry": "Omplanlegging av Lenke vil Utløper",
      "before_meeting": "Før the Konferanse",
      "cancellation_and_reschedule_policy": "Avbestillings- og ombookingspolicy:",
      "meeting_invite_notes": "Notater for møteinvitasjon",
      "meeting_invite_notes_tooltip": "Legg til notater som vil vises i kalenderinvitasjonen som sendes til kunder. Disse notatene vil synkroniseres med tredjepartskalendere i møtebeskrivelsen."
    },
    "connections": {
      "connections_heading": "Ekstern kalendersynkronisering",
      "booking_channels_heading": "Bestillingskanaler",
      "booking_channels_description": "Konfigurer hvordan denne kalenderen mottar bestillinger fra eksterne plattformer.",
      "connections_sub": "Synkroniser møter med eksterne kalendere og administrer hvordan hendelser håndteres.",
      "link_to_calendar": "Lenke til kalenderen",
      "sync_option": "Alternativ for Synkronisering",
      "execute_automation": "Gjennomfør automatisering",
      "fire_workflow": "Aktiver arbeidsflyttriggere for hendelser som er bestilt via toveis synkronisering.",
      "reserve_with_google": "Reserver med Google [utgått]",
      "reserve_with_google_setup": "Vis instruksjoner for oppsett",
      "reserve_with_google_configure": "Konfigurere",
      "change": "Endre",
      "rwg_deprecation_notice": "Google har avviklet <b>Reserver med Google (Local Services Ads)</b>. Nye tilkoblinger eller endringer i eksisterende tilkoblinger støttes ikke lenger. For å fortsette å motta bestillinger fra Google, bruk <b>Organisk booking via Google</b> i stedet.",
      "rwg_category": "Kategori",
      "rwg_service_type": "Tjeneste",
      "connect_lsa": "Koble til annonsekontoen for lokale tjenester.",
      "reserve_error": "nå Booke med Google støttes bare for «Home Tjenester», «Real Estate», «Legal Tjenester» (lokale tjenesteleverandører) Bedrift Niche in USA.",
      "one_way": "Enveis",
      "two_way": "Toveis",
      "smart": "Smart",
      "confirm_remove": "Er du sikker på at du vil Ekstrahere Google Kalender?",
      "read_only_access": "Du trenger ikke skrive Tilgang til denne kalenderen. Velg en annen kalender.",
      "reserve_with_google_desc": "Denne kalendertjenesten vil kun være oppført in Booke med Google ved vellykket integrering.",
      "check_integration": "Hake Status din",
      "setup_external": "Sett opp ekstern kalender",
      "reserve_price_decimal_error": "Desimalpris støttes ikke.",
      "reserve_price_max_error": "Pris kan ikke være lavere enn 1000.",
      "link_to_calendar_tooltip": "Velg den eksterne kalenderen for å synkronisere møter med. Google-kalendere som er koblet til i Kalenderinnstillinger → Tilkoblinger kan velges.",
      "one_way_sync": "Én vei",
      "default_one_way": "Standard synkronisering (enveis synkronisering)",
      "one_way_sync_desc": "Hendelser fra den tilkoblede kalenderen synkroniseres som blokkerte tidsluker, og ingen kontakter opprettes for gjestene.",
      "two_way_sync": "Toveis synkronisering",
      "two_way_sync_desc": "Kontakter blir opprettet for gjester funnet i tilknyttede kalenderhendelser, og disse hendelsene gjøres om til systemavtaler.",
      "smart_sync": "Smart synkronisering",
      "smart_sync_desc": "Hendelser fra den tilknyttede kalenderen synkroniseres som avtaler for eksisterende kontakter. Hvis ingen kontakt eksisterer, synkroniseres de som blokkerte tidsluker uten å opprette en ny kontakt.",
      "sync_option_tooltip": "Velg hvordan hendelser fra den eksterne kalenderen skal håndteres:\n• Enveis: Blokkerer tid i denne kalenderen uten å opprette {contactsLabel}\n• Toveis: Oppretter møter og {contactsLabel} fra eksterne kalenderhendelser\n• Smart: Oppretter kun møter for eksisterende {contactsLabel}, og blokkerer tid for andre.",
      "default_sync": "Standard",
      "default_sync_desc": "Synkroniserer hendelser fra din eksterne kalender til denne kalenderen.",
      "advanced_sync": "Avansert",
      "advanced_sync_desc": "Synkroniserer hendelser fra din eksterne kalender til denne kalenderen og oppretter kontakter og avtaler i systemet.",
      "assign_contact_to": "Tildel kontakt til",
      "select_calendar": "Velg kalender",
      "sync_preferences": "Synkroniseringsinnstillinger",
      "sync_preferences_desc": "Hvordan ønsker du å synkronisere dine tilkoblede kalenderhendelser?",
      "recommended": "Anbefalt",
      "execute_automation_desc": "Utfør automatisering når et møte opprettes i denne kalenderen.",
      "save": "Lagre endringer",
      "cancel": "Kanseller",
      "reserve_with_google_title": "Reserve with Google",
      "current_connection": "Gjeldende aktive tilkobling:",
      "category": "Kategori",
      "service": "Tjenestetype",
      "price": "Estimert pris",
      "currency": "Valuta"
    },
    "booking_rules": {
      "booking_rules": "Regler for bestilling",
      "booking_rules_description": "Administrer hvordan og når møter kan bestilles."
    },
    "payments": {
      "payments": "Payments",
      "payments_description": " Enable and manage payments, rules, and charge models."
    },
    "extras": {
      "extras": "Tilpasninger",
      "extras_sub": "Samling Widget stil og Annen/annet Innstillinger.",
      "calendar_widget_style": "Stil for Widget",
      "neo": "Ny",
      "classic": "Klassisk",
      "insert_custom_code": "Sett inn Egendefinert kode",
      "show_seats_per_slot": "Vise Seter per tidsluke",
      "allow_reschedule_meeting": "Aktivere Planlegge på nytt Konferanse",
      "allow_cancelling_meeting": "Aktivere avbryter Konferanse",
      "additional_notes": "Ytterligere merknader",
      "cancellation_and_reschedule": "Avbestilling og Planlegge på nytt:",
      "allow_staff": "Aktivere personalvalg ved bestilling",
      "code_block_tooltip": "Tredjepartsskript Indre HTML blokken kan Tilbud kraftig funksjonalitet, men de medfører også risiko for personvern, sikkerhet, ytelse og sideoppførsel. Derfor anbefaler vi at Du til Vurdering Innhold av denne Koden Før Lagrer den til kalenderen.",
      "calendar_image": "Kalenderens forsidebilde",
      "remove_image": "Ekstrahere Bilde",
      "calendar_image_info": "Det opplastede bildet vil være synlig i gruppevisningen for Neo-malen og vises ikke på den individuelle kalenderlenken.",
      "get_image_from_unsplash": "Forbedre det visuelle med",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Konfigurer flere preferanser",
      "service_image": "Tjenestens forsidebilde",
      "service_image_description": "Velg et bilde som skal vises på tjenestemenyen for denne tjenesten.",
      "allow_reschedule_appointment": "Aktivere Planlegge på nytt Avtale",
      "allow_cancelling_appointment": "Aktivere avbryter Avtale",
      "custom_code_placeholder": "Vennligst tilbakemelding Egendefinert kode her",
      "calendar_widget_style_desc": "Velg mellom vår klassiske eller den elegante Neo-widgeten.",
      "seats_per_slot": "Seter per tidsluke",
      "show_staff_selection": "Personalutvalg",
      "seats_per_slot_desc": " Aktivere Booker for å se den høye av tilgjengelige Seter per Tidsvindu direkte På kalender- Widget.",
      "show_staff_selection_desc": "Gjør det mulig for bestillere å velge en ansatt direkte fra kalenderwidgeten under avtalebestilling. Fungerer kun med Neo-widgeten.",
      "widget_re_order_tooltip": "Den klassiske widget-stilen tillater ikke endringer i widget-bestilling. Sørg for at dato- og klokkeslettvelgeren er først og skjemaet er nummer to før du velger den klassiske stilen.",
      "show_staff_selection_desc_service": "Aktivere Booker for å velge en medarbeider Medlemmer direkte Fra kalender- Widget under Avtale-booking.",
      "switch_to_classic_widget": "Bytt til den klassiske widgeten",
      "switch_to_classic_widget_desc": "Bytte til den <b>klassiske widgeten</b> vil automatisk deaktivere følgende innstillinger, da de ikke kan eksistere samtidig:",
      "form_first_disabled": "<b>Skjema vil bli flyttet til den andre Sritt</b> in Widget sorteringen.",
      "appointment_preference_disabled": "<b>Ny avtalepreferanse (alltid bestill med {contactLabel}s tildelte bruker)</b> vil bli deaktivert. Dette betyr at avtaler kan lages med et hvilket som helst tilgjengelig teammedlem, i stedet for å være begrenset til {contactLabel}s tildelte bruker.",
      "multiple_location_disabled": "<b>Flere Konferanse Adresse</b> blir Slettet, og kun <b>Sted som er lagt til først</b> vil bli beholdt.",
      "insert_custom_code_tooltip": "Tilpass utseendet til widgeten ved å bruke din egen CSS-kode.",
      "classic_tooltip_disabled": "Klassisk widget støttes ikke for kalendere for klassebestilling.",
      "show_staff_selection_disabled_tooltip": "Personalvalg støttes kun for neo-widgeten."
    },
    "roomsAndEquipments": {
      "title": "Velg rom og utstyr",
      "description": "Velg fra en liste over rom og utstyr som skal bestilles sammen med denne kalenderen.",
      "rooms": "Utvalgte rom",
      "equipments": "Velg utstyr"
    }
  },
  "activity_log": {
    "activity_log": "Aktivitetslogg",
    "date": "Dato",
    "filter_by": "Filtrer via",
    "calendar_update": "Oppdatering av kalender",
    "start_time_update": "Oppdatering av starttid",
    "end_time_update": "Oppdatering av sluttid",
    "title_update": "Oppdatering av tittel",
    "notes_update": "Oppdatering av notater",
    "appointment_status_update": "Oppdatering av avtalestatus",
    "meeting_location_update": "Oppdatering av møtested",
    "google_sync_update": "Oppdatering av Google-synkronisering",
    "outlook_sync_update": "Oppdatering av Outlook-synkronisering",
    "assigned_user_update": "Oppdatering av tilordnet bruker",
    "appointment_status": "Avtalestatus",
    "assigned_user": "Tilordnet bruker",
    "uploaded_to": "Lastet opp til",
    "cancelled": "Kansellert",
    "edited": "redigert",
    "other_edits": "Andre redigeringer",
    "view_details": "Vis detaljer",
    "all": "Alle"
  },
  "appointment_list": {
    "group_all": "ALLE",
    "group_primary": "PRIMÆRE",
    "group_user": "BRUKERE",
    "group_team": "GRUPPER",
    "group_calendar": "KALENDERE",
    "all_appointments": "Alle avtaler",
    "my_calendar": "Min kalender",
    "status_all": "Alle",
    "status_confirmed": "Bekreftet",
    "status_new": "Ny (handling påkrevd)",
    "status_show": "Vist",
    "status_no_show": "Ikke møtt",
    "status_cancelled": "Kansellert",
    "status_invalid": "Ugyldig",
    "filter_date_added_desc": "Dato lagt til (synkende)",
    "filter_start_added_desc": "Startdato (synkende)",
    "filter_start_added_asc": "Startdato stigende fra i dag",
    "button_new_appointment": "Ny avtale",
    "name": "Navn",
    "title": "Tittel",
    "requested_time": "Ønsket tid",
    "date_added": "Dato lagt til",
    "calendar": "Kalender",
    "appointment_owner": "Avtaleeier",
    "notes": "Notater",
    "status": "Status",
    "action_view_detail": "Vis detaljer",
    "action_view_consent": "Vis tillatelse",
    "action_view_notes": "Se notater",
    "action_edit": "Rediger",
    "action_delete": "Slett",
    "action_reschedule": "Planlegge på nytt",
    "page_previous": "Forrige",
    "page_next": "Neste",
    "appointment_notes": "Avtalenotater",
    "close": "Lukk",
    "confirm_delete_header": "Slett avtale",
    "confirm_delete_message": "Er du sikker på at du vil slette denne avtalen? Denne handlingen kan ikke angres.",
    "confirm_delete_button": "Slett",
    "confirm_update_header": "Oppdater avtalestatus",
    "confirm_update_confirmed_message": "Er du sikker på at du vil markere denne avtalen som bekreftet?",
    "confirm_update_invalid_message": "Er du sikker på at du vil markere denne avtalen som ugyldig?",
    "confirm_update_showed_message": "Er du sikker på at du vil markere denne avtalen som møtt opp?",
    "confirm_update_noshow_message": "Er du sikker på at du vil markere denne avtalen som ikke møtt opp?",
    "confirm_update_cancelled_message": "Er du sikker på at du vil markere denne avtalen som kansellert?",
    "confirm_update_button": "Oppdater",
    "empty_state_title": "Ingen avtaler funnet",
    "empty_state_description": "Ingen avtaler funnet.",
    "disable_menu_warning": "For øyeblikket har du ikke tillatelse til å vise eller redigere avtaledetaljer, siden den tilknyttede kontakten ikke er tilordnet deg. Ta gjerne kontakt med admin for ytterligere hjelp.",
    "no_contact_warning": "Du har ikke tilgang til kontaktinformasjon for øyeblikket. Dette kan være fordi kontakten ikke er tilordnet deg. Ta kontakt med admin for å få hjelp.",
    "consent_label": "Tillatelse",
    "ip_address": "IP",
    "youre_viewing_in": "Vises for øyeblikket i",
    "appointment_delete_msg": "<b>Merk:</b> Avtalen som er slettet herfra, blir ikke slettet fra Calendly.",
    "rescheduled": "Planlagt på nytt"
  },
  "add_guest": {
    "guest_label": "Gjest(er)",
    "search_placeholder": "Søke Fra Venner",
    "add_new": "Legge til ny",
    "save": "Arkivere",
    "close": "Lukke",
    "name": "Navn",
    "phone": "Telefon",
    "email": "E-post",
    "guest_label_count": "Antall Gjest(er).",
    "guest_count_error": "Antall Gjest bør være mellom 1 og 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Detaljer om tjenestemenyen",
    "select_groups_header": "Velg tjenester",
    "arrange_groups_header": "Konfigurer Tjenesteren din",
    "new_service_menu": "Ny tjenestemeny",
    "service_menu_sub_title": "Skap en Tilpasset-servicemeny for din Kunder in bare noen få klikk",
    "quick_tip": "Du kan Inkludere Gruppe til servicemenyen",
    "service_menu_name": "Navn på tjenestemeny",
    "service_menu_description": "Beskrivelse",
    "service_menu_slug": "Tjeneste-URL",
    "select_groups_calendars": "Velge Gruppe og kalendere",
    "select_groups_calendars_desc": "Legg til tjenester i tjenestemenyen",
    "select_all": "Velg alle",
    "arrange_groups": "Konfigurere Sortere av Tjenester",
    "arrange_groups_desc": "Bestem Prosess av Tjenester På servicemenyen",
    "arrange_services_quicktip": "For å Planlegge på nytt-kalendere i Gruppe, gå til Gruppe > Alternativer > Planlegge på nytt-kalendere.",
    "enable_add_guest_desc": "Aktivere Kunder to Inkludere ekstra gjester Når du booker.",
    "enable_multiple_service_desc": "Aktivere Kunder to Booke flere Tjenester in en Individuell Avtale.",
    "enable_staff_selection_desc": "Aktivere Kunder til Velge foretrukket ansatte Medlemmer Når du booker.",
    "enable_add_guest": "Aktiver legge til gjester",
    "enable_multiple_service": "Aktiver valg av flere tjenester",
    "enable_staff_selection": "Aktiver personalvalg",
    "additional_options": "Ytterligere alternativer",
    "code_block_tooltip": "Tredjepartsskript Indre HTML blokken kan Tilbud kraftig funksjonalitet, men de medfører også risiko for personvern, sikkerhet, ytelse og sideoppførsel. Derfor anbefaler vi at Du til Vurdering Innhold av denne Kode Før Lagrer den til servicemenyen.",
    "custom_code_placeholder": "Vennligst tilbakemelding Egendefinert kode her",
    "insert_custom_code": "Sett inn Egendefinert kode",
    "no_service": "funnet ingen tjeneste",
    "no_service_desc": " Ingen Tjenester funnet. Skape Tjenester og Inkludere dem til Gruppe for å Skape en servicemeny.",
    "learn_more": "Les mer",
    "no_service_selected": "Ingen tjeneste Valgt",
    "create_service_calendars": "Skape tjenestekalendere",
    "alert_description": " For å kunne opprette en tjenestemeny må du opprette tjenestekalendere og legge dem til grupper.",
    "dont_show_again": "Ikke vis dette igjen",
    "service_name_required": "Navn på tjenestemeny er påkrevd",
    "slug_already_taken": "Denne Slug-en er allerede tatt",
    "slug_required": "Slug er obligatorisk",
    "please_enter_name": "Skriv inn et navn",
    "service_name_placeholder": "Hovedmeny",
    "service_slug_placeholder": "hovedmeny",
    "form_label": "Skjema",
    "consent_label": "Tillatelse Avmerkingsboks",
    "consent_input_placeholder": "Legg til samtykketekst",
    "consent_tooltip": "Slå på dette alternativet for å tillate innhenting av samtykke fra {contactsLabel} når de oppgir telefonnummeret sitt under bestillingsprosessen for avtaler.",
    "back_message": "Tilbake til Liste",
    "saving_changes": "Bare et minutt — Lagrer den siste Dynamisk...",
    "payment_provider_warning": "Til info: Servicemenyer støtter for øyeblikket kun betalinger via Stripe og Authorize.net. Siden standardleverandøren din er en annen, blir betalingsinnkreving for utvalgte kalendere med aktivert betaling hoppet over.",
    "aria": {
      "consent_form_toggle": "Bryter for samtykkeskjema",
      "enable_add_guest_toggle": "Aktivere bryter for å legge til gjest",
      "enable_multiple_services_toggle": "Aktiver bryter for flere tjenester",
      "enable_staff_selection_toggle": "Aktiver bryter for personalvalg"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Tilpasse-kalender- Widget",
    "works_with_neo_widget": "Fungerer bare med Neo Widget",
    "customise_widget_desc": "Tilpasse Widget Utseende: PRIMÆR Farge, Bakgrunn Farge og Knapp Hoveddel.",
    "learn_more": "Les mer",
    "primary_settings": "PRIMÆR Innstillinger",
    "primary_settings_desc": "Konfigurer primærfarge, bakgrunnsfarge og andre widgetpreferanser for å tilpasse kalenderwidgeten din.",
    "primary_color": "PRIMÆR Farge",
    "primary_color_desc": "Definer fargen for knapper, datoer, tidsluker og handlinger.",
    "background_color": "Bakgrunn Farge",
    "background_color_desc": "Samling av Bakgrunn Farge som fungerer som bakteppe for både dato-time og Skjema.",
    "button_text": "Knapp Hoveddel",
    "button_text_desc": "Tilpass teksten som vises på knappen når du bestiller en avtale.",
    "calendar_title": "Kalendertittel",
    "calendar_title_desc": "Navnet på kalenderen din",
    "calendar_description": "Kalenderbeskrivelse",
    "calendar_description_desc": "Den angitte beskrivelsen.",
    "calendar_details": "Kalenderdetaljer",
    "calendar_details_desc": "Inkluderer informasjon som varighet, dato og tid, gjentakelsesdetaljer og tidssone.",
    "reset_to_default": "Tilbakestill til Standard",
    "preview_widget": "Forhåndsvisning av widget",
    "calendar_title_tooltip": "Angi om kalendernavnet og gruppenavnet (hvis aktuelt) skal være synlige i bestillingswidgeten.",
    "calendar_description_tooltip": "Angi om kalenderbeskrivelsen skal være synlig i bestillingswidgeten.",
    "calendar_details_tooltip": "Samling Hvis de viktige møtene Detaljer som Konferanse Varighet, Valgt Dato & Dato og informasjon om gjentakelser (hvis aktuelt) skal være synlige på Bestillingswidgeten.",
    "insert_custom_code_tooltip": "Tilpasse Widget -styling Via din egen CSS kode.",
    "staff_selection_tooltip": "Aktivere Booker for å velge en medarbeider Medlemmer direkte Fra kalender- Widget under Avtale-booking. Fungerer bare med Neo Widget."
  },
  "eventNotification": {
    "customFields": "Egendefinerte felt",
    "customValues": "Egendefinerte verdier",
    "guest": "Gjest",
    "assignedUser": "Tilordnet bruker",
    "additionalEmails": "Ytterligere e-poster",
    "list": {
      "booked": {
        "title": "Avtale bestilt (Status: Ubekreftet)",
        "modalTitle": "Avtale bestilt (Status: Ubekreftet)",
        "note": "Dette varselet sendes når det opprettes en ny avtale med statusen ubekreftet.",
        "subTitle": "Varsler når en time er bestilt med ubekreftet status."
      },
      "confirmation": {
        "title": "Avtale booket (status: bekreftet)",
        "modalTitle": "avtale booket (status: bekreftet)",
        "note": "Dette varselet sendes når en avtale opprettes med, eller oppdateres til, bekreftet status.",
        "subTitle": "Varsler når en avtale er bekreftet."
      },
      "cancellation": {
        "title": "Avbestilling",
        "modalTitle": "avbestilling",
        "note": "Dette varselet sendes når en avtale blir kansellert, når det er manglende oppmøte, eller den blir merket som ugyldig.",
        "subTitle": "Varsler når en avtale avlyses."
      },
      "reschedule": {
        "title": "Planlegg på nytt",
        "modalTitle": "ombooking",
        "note": "Denne notifikasjonen er sendt når en Avtale er planlagt på nytt. Den utløses kun hvis Avtalen in ubekreftet eller bekreftet Status.",
        "subTitle": "Varsler når en avtale blir flyttet."
      },
      "reminder": {
        "title": "Påminnelse",
        "modalTitle": "påminnelse",
        "note": "Denne notifikasjonen er sendt som en Påminnelse Før Avtale. Den utløses kun hvis Avtalen in ubekreftet eller bekreftet Status.",
        "subTitle": "Sender en påminnelse før avtalen."
      },
      "followup": {
        "title": "Oppfølging",
        "modalTitle": "oppfølging",
        "note": "Denne meldingen er sendt etter avtalen som en oppfølging. Den utløses bare hvis avtalen har status som ubekreftet, bekreftet, eller møtt opp.",
        "subTitle": "Sender en oppfølgingsmelding etter at avtalen er gjennomført."
      }
    },
    "saveToastMsg": "Innstillingene er lagret.",
    "saveToastMsgDesc": "Endringene dine har blitt lagret.",
    "enableSuccess": "Notifikasjoner er aktivert.",
    "disableSuccess": "Notifikasjoner er deaktivert.",
    "tooltip": "Denne notifikasjonen er deaktivert. Vennligst aktiver den for å gjøre endringer.",
    "enabled": "Aktivert",
    "disabled": "Deaktivert",
    "statusLabel": "Statusetiketter",
    "email": {
      "channelName": "E-post",
      "noneTemplate": "Ingen",
      "notificationLabel": "Hvem skal motta denne varslingen?",
      "sendButtonLabel": "Send test-e-post",
      "testEmailLabel": "Test-e-post",
      "testEmailPlaceholder": "Skriv inn mottakerens e-postadresse for testing",
      "body": "E-postens hoveddel",
      "bodyPlaceholder": "Skriv inn meldingen din her",
      "subject": "Emne",
      "subjectPlaceholder": "Skriv inn emnet for e-posten",
      "templateLabel": "E-postmal",
      "templatePlaceholder": "Velg en e-postmal eller begynn fra scratch",
      "fromNamePlaceholder": "Skriv inn navn",
      "fromNameLabel": "Avsenders navn",
      "fromAddressLabel": "Fra adresse",
      "alertEmailAddress": "Skriv inn e-postadresser (atskilt med komma)",
      "addMore": "Legg til mer",
      "afterAppointmentEnds": "etter at avtalen avsluttes",
      "beforeAppointmentStarts": "før avtalen starter",
      "durationLabel": "Når vil du sende ut varselet?",
      "disableEmailNotification": "Deaktiver e-postnotifikasjoner",
      "enableEmailNotification": "Aktiver e-postnotifikasjoner",
      "enableSuccess": "E-postnotifikasjon er aktivert.",
      "enableSuccessDesc": "Du vil nå begynne å motta dette varselet",
      "disableSuccess": "E-postnotifikasjon er deaktivert.",
      "disableSuccessDesc": "Du vil ikke lenger motta dette varselet",
      "reset_to_default": "Tilbakestill til Standard",
      "testEmailSuccessTitle": "Test-e-post er sendt.",
      "testEmailSuccessDesc": "Test-e-post har blitt sendt til {email}",
      "testEmailErrorTitle": "Kunne ikke sende test-e-post",
      "testEmailErrorDesc": "Det oppsto en feil under sending av test-e-posten. Prøv igjen.",
      "create_new_email_template": "Opprett ny e-postmal"
    },
    "inApp": {
      "channelName": "I appen",
      "title": "Varslingsinnstillinger",
      "enableInAppNotification": "Aktiver notifikasjoner i appen",
      "disableInAppNotification": "Deaktiver notifikasjoner i appen",
      "selectedUser": {
        "label": "Send til",
        "helperText": "Denne interne notifikasjonen sendes via nett- og mobilapper.",
        "placeholder": "Velg bruker(e)"
      },
      "enableSuccess": "Notifikasjon(er) i appen er aktivert.",
      "enableSuccessDesc": "Du vil nå begynne å motta denne notifikasjonen.",
      "disableSuccess": "Notifikasjoner i appen er deaktivert.",
      "disableSuccessDesc": "Du vil ikke lenger motta denne notifikasjonen."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Ingen",
      "notificationLabel": "Hvem skal motta denne varslingen?",
      "sendButtonLabel": "Send test-SMS",
      "testSMSLabel": "Test SMS (skriv inn telefonnummer med landskode)",
      "testSMSPlaceholder": "+12345678901",
      "body": "SMS-melding",
      "bodyPlaceholder": "Skriv inn SMS-meldingen din her",
      "durationLabel": "Når vil du sende ut varselet?",
      "disableSMSNotification": "Deaktiver SMS-notifikasjoner",
      "enableSMSNotification": "Aktiver SMS-notifikasjoner",
      "enableSuccess": "SMS-notifikasjon er aktivert!",
      "enableSuccessDesc": "Du vil nå begynne å motta denne notifikasjonen.",
      "disableSuccess": "SMS-notifikasjon er deaktivert.",
      "disableSuccessDesc": "Du vil ikke lenger motta denne notifikasjonen.",
      "alertPhoneNumbers": "Skriv inn telefonnumre (med landskoder, adskilt med komma)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Legg til mer",
      "afterAppointmentEnds": "etter at avtalen avsluttes",
      "beforeAppointmentStarts": "før avtalen starter",
      "templateLabel": "SMS-mal",
      "templatePlaceholder": "Velg SMS-mal ...",
      "reset_to_default": "Tilbakestill til standard",
      "testSmsSuccessTitle": "Test-SMS er sendt.",
      "testSmsSuccessDesc": "Test-SMS ble sendt til {phone}.",
      "testSmsErrorTitle": "Kunne ikke sende test-SMS",
      "testSmsErrorDesc": "Det oppstod en feil ved sending av test-SMS-en. Prøv igjen."
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Hvem skal motta denne varslingen?",
      "sendButtonLabel": "Send testnotifikasjon på WhatsApp",
      "testWhatsAppLabel": "Test notifikasjon fra WhatsApp (skriv inn telefonnummer med landskode)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Når vil du sende ut varselet?",
      "alertPhoneNumbers": "Skriv inn telefonnumre (med landskoder, adskilt med komma)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Legg til mer",
      "afterAppointmentEnds": "etter at avtalen avsluttes",
      "beforeAppointmentStarts": "før avtalen starter",
      "templateLabel": "WhatsApp-mal",
      "templatePlaceholder": "Velg WhatsApp-mal ...",
      "noPreview": "Ingen mal er valgt",
      "templateRequired": "Mal er obligatorisk",
      "testWhatsAppSuccessTitle": "Testnotifikasjon på WhatsApp er sendt.",
      "testWhatsAppSuccessDesc": "WhatsApp-testnotifikasjon er sendt til {phone}.",
      "testWhatsAppErrorTitle": "Kunne ikke sende WhatsApp-testnotifikasjon.",
      "testWhatsAppErrorDesc": "Det oppstod en feil ved sending av WhatsApp-testnotifikasjonen. Prøv igjen.",
      "setupTitle": "Ta kontakt med kunden din på deres favorittmeldingsapp.",
      "setupDescription": "Kom deg nærmere kundene dine ved å tilby øyeblikkelig støtte, sende oppdateringer på riktig tidspunkt og skape engasjerende interaksjoner.",
      "connectWhatsApp": "Koble til WhatsApp",
      "checkingStatus": "Sjekker kontostatus på WhatsApp …",
      "checkingTemplateStatus": "Sjekker WhatsApp-malstatus …",
      "statusCheckError": "Kunne ikke sjekke kontostatus på WhatsApp.",
      "templateStatusCheckError": "Kunne ikke sjekke statusen for WhatsApp-malen.",
      "setupTemplateTitle": "Fullfør oppsettet av WhatsApp-malen.",
      "setupTemplateDescription": "Du må Konfigurere WhatsApp-maler Før du kan Laste opp varsler. Klikk nedenfor for å fullføre konfigureringen.",
      "loadTemplatesError": "Kunne ikke laste inn WhatsApp-maler.",
      "templatesRefreshed": "Maler ble oppdatert",
      "templatesRefreshError": "Kunne ikke oppdatere maler.",
      "templatesResolveError": "Feil ved løsning av standardmaler på WhatsApp.",
      "locationNotFound": "Steds-ID ble ikke funnet.",
      "settingsRedirectError": "Kan ikke omdirigere til WhatsApp-innstillinger.",
      "updateNotificationError": "Kunne ikke oppdatere WhatsApp-notifikasjon.",
      "notificationsEnabled": "WhatsApp-notifikasjoner er aktivert.",
      "notificationsDisabled": "WhatsApp-notifikasjoner er deaktivert.",
      "updateError": "Feil oppsto ved oppdatering av notifikasjoner.",
      "createNewTemplate": "Opprett ny WhatsApp-mal",
      "phoneValidation": {
        "countryCodeRequired": "Telefonnummeret må begynne med en landskode (f.eks. +1, +91, +44)",
        "digitsOnly": "Telefonnummeret må kun inneholde sifre etter landskoden.",
        "tooShort": "Telefonnummeret er for kort.",
        "tooLong": "Telefonnummeret er for langt.",
        "invalid": "Ugyldig telefonnummer."
      },
      "errors": {
        "templateNotFound": "Mal-ID ble ikke funnet i de innlastede alternativene, sletter.",
        "templateNoLongerValid": "Lagret mal er ikke lenger gyldig, sletter.",
        "invalidTemplateSelection": "Forsøkte å velge en ugyldig WhatsApp-mal.",
        "fetchingTemplates": "Feil ved henting av WhatsApp-maler.",
        "mountingCreator": "Feil ved montering av WhatsApp-malskaper.",
        "fetchingAfterCreation": "Feil ved henting av WhatsApp-maler etter opprettelse.",
        "updateStatus": "Feil i oppdatering av WhatsApp-status."
      },
      "receiverLabels": {
        "assignedUser": "Tilordnet bruker",
        "phoneNumbers": "Ytterligere telefonnumre"
      }
    }
  },
  "smsTemplate": {
    "create_new_template": "Opprett ny SMS-mal",
    "create_new_template_desc": "Opprett en gjenbrukbar SMS-mal for dine notifikasjoner.",
    "template_name": "Navn på mal",
    "template_name_placeholder": "Skriv inn navnet på malen",
    "message": "Melding",
    "message_placeholder": "Skriv inn SMS-meldingen din her.",
    "create_template": "Opprett mal",
    "name_required": "Navn på mal er obligatorisk",
    "text_required": "Meldingstekst er obligatorisk",
    "fetch_new_templates": "Oppdater maler",
    "characters": "tegn",
    "words": "ord",
    "segments": "segmenter"
  },
  "whatsappTemplate": {
    "create_new_template": "Opprett ny WhatsApp-mal",
    "create_new_template_desc": "Opprett en gjenbrukbar WhatsApp-mal for dine notifikasjoner.",
    "template_name": "Navn på mal",
    "template_name_placeholder": "Skriv inn navnet på malen",
    "message": "Melding",
    "message_placeholder": "Skriv inn WhatsApp-meldingen din her.",
    "create_template": "Opprett mal",
    "name_required": "Navn på mal er obligatorisk",
    "text_required": "Meldingstekst er obligatorisk",
    "fetch_new_templates": "Oppdater maler"
  },
  "archivedServices": {
    "servicesBanner": "En ny, oppgradert versjon av tjenestene er her – mer kraftig, fleksibel og intuitiv. Tjenestekalenderne dine har allerede blitt migrert. Utforsk dem nå i Tjenester-fanen.",
    "archivedServiceCalendars": "Tjenestekalendere (v1)",
    "check_new_services": "Sjekk nye tjenester"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Rediger kalender",
      "share_calendar": "Del kalender",
      "troubleshoot_calendar": "Feilsøk kalender",
      "more_options": "Flere alternativer",
      "edit_calendar_desc": "Administrere hver eneste kalenderinnstillinger—Satt Tilgjengelighet, Konfigurere Påminnelse, Endre Avtale limits og mer.",
      "share_calendar_desc": "Kopier og slett Planleggingslenke slik at Booker enkelt kan planlegge med Du.",
      "troubleshoot_calendar_desc": "Finn ut hvorfor et spor ikke vises, og se mulige årsaker i feilsøkingsvisningen.",
      "more_options_desc": "Tilgang flere Innstillinger og aktiviteter for å Administrere kalenderen din.",
      "read_permissions": {
        "share_description": "Gi tilgang til andre ved å dele kalenderlenken eller justere tillatelsene.",
        "troubleshoot_description": "Identifiser og løs problemer som synkroniseringsfeil eller manglende hendelser for å sikre god funksjonalitet."
      },
      "next": "Neste",
      "start_over": "Start på nytt",
      "all_set": "Alt klart!",
      "previous": "Forrige"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Velg redigeringsverktøy",
    "select_editing_experience_desc": "Velg å bygge ved hjelp av vår visuelle dra-og-slipp designredigerer eller vår kraftige koderedigerer.",
    "design_editor": "Designredigerer",
    "design_editor_desc": "Visuell redigering med dra-og-slipp.",
    "code_editor": "Koderedigerer",
    "code_editor_desc": "HTML-redigering med omfattende funksjoner.",
    "text_editor": "Ren tekst-redigerer",
    "text_editor_desc": "Grunnleggende, ren og enkel tekstredigering.",
    "email_text_block": "E-post kan også være Opprettet Via Hoveddel Block. ",
    "select": "Velge",
    "new_template": "Ny mal",
    "email_block": "E-post kan også opprettes ved hjelp av tekstblokk.",
    "fetch_new_templates": "Hent nye maler"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Bruk et tydelig møtenavn og en tydelig beskrivelse slik at kundene vet nøyaktig hva de planlegger.",
      "groups_share_link": "Grupper lar deg dele en planleggingslenke for flere kalendere, slik at kunder kan velge og bestille fra tilgjengelige alternativer."
    },
    "staff_location": {
      "custom_location": "Velg Tilpasset som møtested for å legge inn en hvilken som helst adresse eller lenke du ønsker.",
      "ask_booker_location": "Når Spør bestilleren er valgt, blir bestilleren bedt om å oppgi møtested under bookingen",
      "round_robin_priority": "Prioritetsinnstillinger påvirker hvordan møter blir fordelt når flere ansatte er tilgjengelige.",
      "connect_video_integrations": "Koble til videokonferanseintegrasjoner fra Kalenderinnstillinger → Forbindelser før du velger dem som møtested."
    },
    "availability": {
      "staff_availability_required": "Møter kan bare bestilles når minst én valgt ansatt er tilgjengelig.",
      "use_precreated_schedule": "Du kan bruke en forhåndsopprettet tilgjengelighetsplan fra Kalenderinnstillinger → Tilgjengelighet, eller du kan opprette en egendefinert plan kun for denne kalenderen.",
      "timezone_in_schedule": "Tidssonen for møter er angitt innenfor den valgte tilgjengelighetsplanen.",
      "event_24_hours": "For å gjøre en kalender tilgjengelig 24 timer i døgnet, sett tidsintervallet fra kl. 00.00 til kl. 00.00."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Bestillingsregler gjelder for alle møter i denne kalenderen, uavhengig av de ansattes tilgjengelighet.",
      "minimum_scheduling_notice": "Øk minimumsvarselet for planlegging for å forhindre bestillinger i siste liten.",
      "maximum_bookings_per_slot": "Bruk maksimalt antall bookinger per tidsluke for å kontrollere hvor mange møter som kan finne sted samtidig."
    },
    "forms": {
      "custom_contact_fields": "Du kan inkludere egendefinerte kontaktfelt i både skjemameldinger og skjema-URL-er.",
      "create_custom_form": "For å samle inn mer informasjon, opprett et egendefinert skjema fra Nettsteder → Skjemaer → Bygger og bruk det med denne kalenderen."
    },
    "payments": {
      "collected_during_booking": "Betalinger innkreves under bestillingen og må fullføres før møtet bekreftes.",
      "payment_description": "Bruk betalingsbeskrivelsen til å tydelig forklare hva beløpet gjelder."
    },
    "notifications": {
      "review_policies": "Gjennomgå retningslinjer for avbestilling og ombooking for å unngå endringer i siste liten.",
      "use_workflows": "For avansert automatisering, bruk arbeidsflyter med triggeren \"Avtale booket\"."
    },
    "customizations": {
      "preview_widget": "Forhåndsvis widgeten for å sikre at den passer med merkevaren din og bestillingsflyten.",
      "update_widget_language": "Språkinnstillingene for widgeten kan endres fra Innstillinger → Kalendere → Innstillinger."
    },
    "connections": {
      "google_organic_booking": "Ved å konfigurere Google Organic Booking kan denne kalenderen motta bestillinger direkte fra Google Søk.",
      "external_sync_event": "Kun kalenderen valgt under Ekstern synkronisering brukes til å hente og sende hendelser for denne kalenderen."
    },
    "equipments": {
      "room_definition": "Et \"rom\" kan representere et hvilket som helst sted der det leveres tjenester. Dette kan være fysiske rom og/eller dedikerte stasjoner. F.eks.: Pedikyrstasjon.",
      "equipment_definition": "Tenk på \"utstyr\" som et hvilket som helst verktøy eller apparat som bedrifter bruker for å oppfylle avtaler. Det kan dreie seg om maskiner, apparater eller til og med stoler."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Klistrede kontakter",
    "consent_form": "Samtykkeskjema",
    "enable_guests": "Aktiver gjester",
    "auto_confirm": "Automatisk bekreftelse",
    "should_accept_payment": "Burde godta betaling",
    "collect_deposit": "Innhenting av depositum",
    "enable_charge_guests": "Aktiver belastning av gjester",
    "enable_coupon": "Aktiver kupong",
    "payment_live": "Betaling i sanntid",
    "add_availability_hour": "Legg til ledig time",
    "remove_availability_hour": "Fjern ledig time",
    "copy_availability_hour": "Kopier ledig time",
    "close_modal": "Lukke modal",
    "add_custom_slot": "Legge til egendefinert tidsluke",
    "remove_custom_slot": "Fjern egendefinert tidsluke",
    "edit_custom_slot": "Rediger egendefinert tidsluke",
    "update_frequency": "Oppdateringsfrekvens",
    "show_calendar_title": "Vis kalendertittel",
    "show_calendar_description": "Vis kalenderbeskrivelse.",
    "show_calendar_details": "Vis kalenderdetaljer",
    "allow_reschedule": "Tillat ombooking",
    "allow_cancellation": "Tillat avbestilling",
    "category_actions": "Kategorihandlinger",
    "show_seats_per_slot": "Vis seter per tidsluke",
    "add_more": "Legg til mer",
    "same_user_assignment_toggle": "Bytt mellom samme brukertilordning"
  },
  "placeholders": {
    "pixel_id": "Pixel-ID",
    "select_one": "Velg én",
    "meeting_location": "Møtested",
    "schedule_meeting": "Planlegg møte",
    "notes": "Notater",
    "select_users": "Velg brukere",
    "please_select": "Velg"
  },
  "alt_text": {
    "payment_provider": "Betalingsleverandør",
    "no_calendars": "Ingen kalendere",
    "date_specific_hours": "datospesifikke timer",
    "custom_widget_image": "Tilpasset widget-bilde",
    "service_calendar": "Tjenestekalender",
    "event_calendar": "Hendelseskalender",
    "round_robin_booking": "Rotasjonsordning for bestilling",
    "class_booking": "Klassebestilling",
    "collective_booking": "Kollektiv bestilling",
    "calendar_cover_image": "Kalenderens forsidebilde",
    "email_notification_switch": "Bryter for e-postvarsling",
    "email_template_icon": "Ikon for e-postmal",
    "in_app_notification_switch": "Bryter for notifikasjon i appen",
    "sms_notification_switch": "Bryter for SMS-notifikasjon",
    "whatsapp_notification_switch": "Bryter for WhatsApp-notifikasjon",
    "no_service_found": "Ingen tjenester funnet",
    "no_group_found": "Ingen gruppe funnet",
    "sync_icon": "Synkroniseringsikon",
    "sync_type": "Synkroniseringstype",
    "test1": "test1",
    "test2": "test2"
  },
  "tooltips": {
    "text_color": "Tekstfarge",
    "background_color": "Bakgrunnsfarge",
    "strikethrough": "Gjennomstreking",
    "superscript": "Hevet skrift",
    "subscript": "Senket skrift",
    "inline_code_block": "Innebygd kodeblokk",
    "code_block": "Kodeblokk",
    "block_quote": "Blokksitat",
    "more": "Flere",
    "upload": "Last opp",
    "image_upload_tooltip": "PNG-, JPEG-, JPG- eller GIF-fil (maks. dimensjoner 180x180px | maks. størrelse 2,5 MB).",
    "custom_values": "Egendefinerte verdier",
    "text_wrap": "Ombryting av tekst",
    "trigger_links": "Trigger-lenker",
    "text_align": "Tekstjustering"
  },
  "labels": {
    "reset_style": "Tilbakestill stil",
    "reset_document_style": "Tilbakestill dokumentstil",
    "source_code": "Kildekode",
    "success": "Utført",
    "edit": "Rediger",
    "submit": "Send inn",
    "cancel": "Kanseller",
    "payment": "Betaling",
    "here_is_the_link": "Her er lenken:",
    "here_is_the_embed_code": "Her er innebygd kode:",
    "service_calendar": "Tjenestekalender",
    "collective_booking": "Kollektiv bestilling",
    "class_booking": "Klassebestilling",
    "round_robin_booking": "Rotasjonsordning for bestilling",
    "event_calendar": "Hendelseskalender",
    "personal_booking": "Personlig bestilling",
    "service_booking": "Tjenestebestilling",
    "calendar_id": "Kalender-ID"
  },
  "validation_messages": {
    "calendar_group_name_required": "Navnet på kalendergruppen er påkrevd.",
    "calendar_group_description_required": "Beskrivelsen av kalendergruppen er påkrevd.",
    "slug_required": "Slug er påkrevd.",
    "slug_not_valid": "Denne sluggen er ikke gyldig.",
    "slug_already_taken": "Denne sluggen er allerede i bruk.",
    "error_validating_slug": "Feil ved validering av slug.",
    "please_enter_name": "Angi et navn.",
    "room_name_required": "Romnavn er obligatorisk",
    "equipment_name_required": "Navn på utstyret er påkrevd.",
    "subject_required": "Emnet er påkrevd.",
    "this_is_required": "Dette er påkrevd.",
    "calendar_group_slug_required": "Kalendergruppe-slug er påkrevd.",
    "capacity_mandatory": "Kapasitet er påkrevd.",
    "capacity_cannot_be_zero": "Kapasitet kan ikke være null.",
    "capacity_should_be_a_number": "Kapasitet skal være et tall.",
    "capacity_cannot_be_negative": "Kapasitet kan ikke være negativ.",
    "capacity_should_be_a_whole_number": "Kapasitet skal være et heltall.",
    "quantity_mandatory": "Mengde er påkrevd",
    "quantity_cannot_be_zero": "Mengde kan ikke være null.",
    "quantity_should_be_a_number": "Mengde skal være et tall.",
    "quantity_cannot_be_negative": "Mengde kan ikke være negativ.",
    "quantity_should_be_a_whole_number": "Mengde skal være et heltall.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "Mengde kan ikke være mindre enn utstyr som er ute av drift.",
    "out_of_service_value_should_be_a_number": "Ute av drift-verdien skal være et tall.",
    "out_of_service_cannot_be_negative": "Ute av drift skal ikke være negativ",
    "out_of_service_equipments_qty": "Utstyr som er ute av drift, kan ikke overstige det faktiske antallet utstyr.",
    "out_of_service_whole_number": "Ute av drift bør være et heltall.",
    "slot_duration_required": "Tidslukens varighet er påkrevd.",
    "slot_duration_integer": "Tidslukens varighet må være et heltall.",
    "meeting_duration_validation": "Møtevarigheten må være mellom 1 min og 12 timer",
    "seats_class_required": "Seter per klasse er påkrevd.",
    "seats_class_integer": "Seter per klasse må være et heltall.",
    "seats_class_validation": "Dette kan ikke være større enn 9999 eller mindre enn 0.",
    "meeting_location_required": "Møtested er påkrevd."
  },
  "custom_values": {
    "assigned_user": "Tilordnet bruker",
    "full_name": "Fullt navn",
    "first_name": "Fornavn",
    "last_name": "Etternavn",
    "email": "E-post",
    "phone": "Telefon",
    "twilio_phone": "Twilio-telefon",
    "account": "Konto",
    "name": "Navn",
    "full_address": "Full adresse",
    "city": "By",
    "state": "Stat",
    "country": "Land",
    "postal_code": "Postnummer",
    "contact": "Kontakt",
    "address1": "Adresse 1",
    "timezone": "Tidssone",
    "user": "Bruker",
    "appointment": "Avtale",
    "start_date_time": "Startdato og klokkeslett",
    "start_date": "Startdato",
    "start_time": "Starttid",
    "end_date_time": "Sluttdato og klokkeslett",
    "end_date": "Sluttdato",
    "end_time": "Sluttid",
    "meeting_location": "Møtested"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Telefon",
    "full_address": "Full adresse",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Tilpasset"
  },
  "duration_units": {
    "minutes": "Minutter",
    "hours": "Timer"
  },
  "widget_styles": {
    "classic": "Klassisk",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Tjenestemeny",
    "rooms": "Rom",
    "equipments": "Utstyr"
  },
  "lsa": {
    "categories": {
      "accountant": "Regnskap",
      "acupuncturist": "Akupunktur",
      "air_duct_cleaner": "Rensing av ventilasjonskanaler",
      "alcohol_treatment": "Behandlingstjenester for alkoholisme",
      "animal_shelter": "Redningstjenesten for dyr",
      "appliance_repair": "Reparasjon av apparater",
      "architect": "Arkitektur",
      "assisted_living": "Assisterte bo-tjenester",
      "babysitter": "Barnevakt",
      "bankruptcy_lawyer": "Konkursjus",
      "beauty_school": "Skjønnhetsskole",
      "business_lawyer": "Forretningsjus",
      "car_repair": "Autotjenester",
      "carpenter": "Snekkerarbeid",
      "carpet_cleaning": "Rensing av tepper",
      "child_care": "Tjenester for barnepass",
      "chiropractor": "Kiropraktortjenester",
      "cleaning_service": "Husvask",
      "contract_lawyer": "Kontraktsjus",
      "countertop_pro": "Benkeplatetjenester",
      "criminal_lawyer": "Straffejus",
      "dance_instructor": "Danseveiledning",
      "disability_lawyer": "Lov om funksjonshemmede",
      "driving_instructor": "Kjøreopplæring",
      "dui_lawyer": "Lov om kjøring i beruset tilstand",
      "electrician": "Elektrisk",
      "energy_efficiency_pro": "Energieffektivitetstjenester",
      "estate_lawyer": "Eiendomsjus",
      "event_planner": "Arrangementplanlegging",
      "family_lawyer": "Familiejus",
      "fencing_pro": "Fekting",
      "financial_planner": "Finansiell planlegging",
      "first_aid_trainer": "Førstehjelpskurs",
      "flooring_pro": "Gulvbelegg",
      "foundation_pro": "Grunnlag",
      "funeral_home": "Begravelsestjenester",
      "garage_door_pro": "Garasjeport",
      "general_contractor": "Oppussing av Hjem",
      "handyman": "Alt-muligmann",
      "home_inspector": "Hjemmeinspeksjon",
      "home_security": "Sikkerhetstjenester for hjemmet",
      "home_theater": "Hjemmekino-tjenester",
      "hvac": "VVS",
      "immigration_lawyer": "Innvandringsjus",
      "interior_designer": "Interiørdesign",
      "ip_lawyer": "Immateriell rettighetsjus",
      "junk_removal": "Fjerning av avfall",
      "labor_lawyer": "Arbeidsjus",
      "landscaper": "Landskapsarkitektur",
      "language_instructor": "Språkundervisning",
      "lawn_care": "Plenpleie",
      "litigation_lawyer": "Søksmålsjus",
      "locksmith": "Låsesmed",
      "malpractice_lawyer": "Malpraksisjus",
      "massage_center": "Massasjetjenester",
      "massage_school": "Massasjeskole",
      "mover": "Flytter",
      "nursing_home": "Tjenester for sykehjem",
      "painter": "Maleri",
      "personal_injury_lawyer": "Personskadeerstatningsjus",
      "personal_trainer": "Personlig kurs",
      "pest_control": "Skadedyrkontroll",
      "pet_adoption": "Adopsjonstjenester for kjæledyr",
      "pet_boarding": "Dyrepensjonat",
      "pet_grooming": "Kjæledyrstell",
      "pet_trainer": "Trening av kjæledyr",
      "photographer": "Fotografi",
      "plumber": "Rørleggerarbeid",
      "pool_cleaner": "Bassengrengjøring",
      "pool_contractor": "Bassengkontraktering",
      "preschool": "Førskoleundervisning",
      "psychologist": "Psykologitjenester",
      "real_estate_agent": "Eiendom",
      "real_estate_lawyer": "Eiendomsjus",
      "rehab": "Rehabiliteringstjenester",
      "roofer": "Taktekking",
      "sewage_pro": "Avløpssystemtjenester",
      "siding_pro": "Forside",
      "smart_home": "Tjenester for smarte hjem",
      "snow_removal": "Måkingstjenester",
      "spa": "Spa-tjenester",
      "tax_lawyer": "Avgiftsjus",
      "tax_specialist": "Avgiftstjenester",
      "therapist": "Terapi",
      "towing_pro": "Veihjelp",
      "traffic_lawyer": "Trafikklov",
      "tree_service": "Trepleietjenester",
      "tutor": "Veiledning",
      "upholstery_cleaner": "Rensing av møbeltrekk",
      "veterinarian": "Veterinærtjenester",
      "videographer": "Videotjenester",
      "water_damage": "Vannskadetjenester",
      "weight_loss_service": "Vekttapstjenester",
      "window_cleaner": "Rensing av vinduer",
      "window_repair": "Vindutjenester",
      "windshield_repair_pro": "Bilglass",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Annen/annet",
      "bankruptcy_tax_litigation": "Skattetvister i forbindelse med konkurs",
      "bookkeeping": "Regnskapsføring",
      "business_consulting": "Forretningskonsulenttjenester",
      "debt_collection_relief": "Avskrivning av gjeld",
      "irs_representation_resolution": "Representasjon og løsning med skattemyndighetene",
      "payroll": "Lønnsadministrasjon",
      "tax_planning_business": "Avgiftsplanleggingsvirksomhet",
      "tax_planning_individual": "Skatteplanlegging for enkeltpersoner",
      "tax_return_business": "Næringsoppgave",
      "tax_return_individual": "Selvangivelse",
      "trusts_estates_accounting": "Regnskap for stiftelser og dødsbo",
      "acupressure": "Akupressur",
      "acupuncture": "Akupunktur",
      "acupuncturist_other": "Annen/annet",
      "cupping": "Koppe-behandling",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Varmebehandling",
      "herbal_therapy": "Urtemedisin",
      "infrared_therapy": "Infrarødterapi",
      "moxibustion": "Moxibusjon",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Rensing av ventilasjonskanaler",
      "air_duct_filter_replacement": "Utskifting av filter",
      "air_duct_other": "Annen/annet",
      "dryer_vent_cleaning": "Rensing av tørketrommelens ventilasjon",
      "furnace_cleaning": "Rensing av fyrkjele",
      "indoor_air_quality_testing": "Testing av innendørs luftkvalitet",
      "alcohol_treatment_other": "Annen/annet",
      "animal_shelter_cat_adoption": "Katteadopsjon",
      "animal_shelter_dog_adoption": "Hundeadopsjon",
      "animal_shelter_other": "Annen/annet",
      "animal_shelter_other_animal_adoption": "Annen dyreadopsjon",
      "animal_shelter_other_veterinary_services": "Andre veterinærtjenester",
      "animal_shelter_spay_neuter": "Sterilisere eller kastrere",
      "animal_shelter_vaccinations": "Vaksinasjoner",
      "lost_stray_found_animals": "Bortkomne, herreløse eller funnede dyr",
      "pet_license": "Lisens for kjæledyr",
      "pet_surrender": "Overlevering av kjæledyr",
      "appliance_other": "Annen/annet",
      "repair_dishwasher": "Reparasjon av oppvaskmaskin",
      "repair_dryer": "Reparere tørketrommel",
      "repair_freezer": "Reparer fryser",
      "repair_microwave": "Reparere mikrobølgeovn",
      "repair_oven": "Reparere ovn",
      "repair_refrigerator": "Reparasjon av kjøleskap",
      "repair_refrigerator_freezer": "Reparasjon av kjøleskap / fryser",
      "repair_stove_cooktop": "Reparasjon av komfyr / platetopp",
      "repair_stove_cooktop_oven": "Reparasjon av komfyr/koketopp/ovn",
      "repair_washer": "Reparasjon av vaskemaskin",
      "repair_washer_dryer": "Reparasjon av vaskemaskin/tørketrommel",
      "3d_architectural_rendering": "3D arkitektonisk visualisering",
      "adaptive_reuse_historical_renovation": "Adaptiv gjenbruk og historisk renovering",
      "architect_other": "Annen/annet",
      "architectural_designing": "Arkitekturdesign",
      "architectural_engineering": "Arkitektonisk ingeniørfag",
      "building_code_analysis_permit_coordination": "Kodeanalyse og tillatelser",
      "consulting": "Konsulenttjenester",
      "home_building_improvement": "Bygging og forbedring av boliger",
      "interior_design_architect": "Interiørdesign",
      "planning_zoning_approval_assistance": "Godkjenning av planlegging og soneinndeling",
      "project_managing_architect": "Prosjektledelse",
      "site_master_planning": "Planlegging av området",
      "assisted_living_housekeeping_and_laundry": "Renhold og vaskeri",
      "assisted_living_meal_services": "Måltidstjenester",
      "assisted_living_memory_care": "Minnepleie",
      "assisted_living_other": "Annen/annet",
      "assisted_living_rehabilitation_services": "Rehabiliteringstjenester",
      "assisted_living_transportation": "Transport",
      "assisted_living_wellness_programs": "Velværeprogrammer",
      "daily_living_assistance": "Assistanse i dagliglivet",
      "medication_management": "Legemiddelhåndtering",
      "short_term_stays": "Korttidsopphold",
      "social_and_recreational_activities": "Fritidsaktiviteter",
      "babysitter_other": "Annen/annet",
      "event_babysitting": "Barnevakt for arrangementer",
      "homework_assistance": "Leksehjelp",
      "housekeeping_laundry": "Renhold og vaskeri",
      "meal_preparation": "Forberedelse av måltid",
      "nanny_services": "Barnepike-tjenester",
      "overnight_babysitting": "Barnevakt over natten",
      "pick_up_and_drop_off": "Henting og levering",
      "shopping_errand": "Handling og ærender",
      "special_needs_care": "Omsorg for personer med spesielle behov",
      "virtual_babysitting": "Virtuell barnepass",
      "agriculture_bankruptcy": "Konkurs i landbruket",
      "bankruptcy_lawyer_other": "Annen/annet",
      "bankruptcy_litigation": "Konkursbehandling",
      "chapter_11_bankruptcy": "Konkurs etter kapittel 11",
      "chapter_13_bankruptcy": "Konkurs etter kapittel 13",
      "chapter_7_bankruptcy": "Konkurs etter kapittel 7",
      "corporate_bankruptcy": "Konkurs i bedrifter",
      "creditor_harassment": "Kreditortrakassering",
      "debt_settlement": "Gjeldsordning",
      "foreclosure_bankruptcy_lawyer": "Tvangsauksjon",
      "personal_bankruptcy": "Personlig konkurs",
      "repossession": "Overtakelse",
      "wage_garnishment": "Lønnstrekk",
      "beauty_school_barbering": "Barbering",
      "beauty_school_business_management": "Bedriftsledelse",
      "beauty_school_cosmetology": "Kosmetologi",
      "beauty_school_esthetics": "Estetikk",
      "beauty_school_hair_cutting": "Hårklipping",
      "beauty_school_hair_design": "Hårdesign",
      "beauty_school_makeup": "Sminke",
      "beauty_school_massage_therapy": "Massasjeterapi",
      "beauty_school_nail_technology": "Negleteknologi",
      "beauty_school_other": "Annen/annet",
      "beauty_school_retail_training": "Kurs i detaljhandel",
      "banking_finance_law": "Bank & Finans",
      "business_lawyer_other": "Annen/annet",
      "business_licenses_permits": "Bedriftslisenser og -tillatelser",
      "business_litigation": "Forretningsrettssaker",
      "business_taxes": "Forretningsskatter",
      "business_transactions_business_lawyer": "Forretningstransaksjoner",
      "commercial_bankruptcy": "Konkurs i næringslivet",
      "commercial_contracts_business_lawyer": "Forretningskontrakter",
      "employment_law_business_lawyer": "Arbeidsjus",
      "incorporation_restructuring": "Inkorporering og omstrukturering",
      "insurance_law": "Forsikringsjus",
      "intellectual_property_law": "Immateriell rettighetsjus",
      "mergers_acquisitions_business_lawyer": "Fusjoner og oppkjøp",
      "partnership_agreements_business_lawyer": "Partnerskapsavtaler",
      "patents_copyrights_trademarks": "Patenter, opphavsrettigheter og varemerker",
      "securities_law": "Verdipapirjus",
      "shareholder_disputes": "Aksjonærtvister",
      "air_and_cabin_filter": "Luft- og kupéfiltrere",
      "battery": "Batteri",
      "body_and_trim": "Karosseri & Trim",
      "brakes": "Bremser",
      "car_air_conditioning": "Klimaanlegg",
      "car_electrical": "Elektrisk",
      "car_repair_other": "Annen/annet",
      "check_engine_light_diagnostic": "Diagnostikk av motorens varsellampe",
      "exhaust": "Eksos",
      "oil_change": "Oljeskift",
      "steering_suspension": "Styring / oppheng",
      "tires": "Dekk",
      "transmission": "Overføring",
      "cabinetry": "Skapinnredning",
      "carpenter_other": "Annen/annet",
      "decking": "Terrassebord",
      "drywalling": "Gipsplater",
      "fencing": "Gjerder",
      "general_installations": "Generelle installasjoner",
      "general_repairs_maintenance": "Generelle reparasjoner & Vedlikehold",
      "remodeling": "Ombygging",
      "shelving_storage": "Hyller & Oppbevaring",
      "carpet_cleaning_other": "Annen/annet",
      "clean_area_rugs": "Rensing av teppeløper",
      "clean_carpet": "Rensing av gulvtepper",
      "clean_drapes_and_curtains": "Rensing av gardiner og forheng",
      "clean_upholstery": "Rensing av møbeltrekk",
      "remove_pet_stains_and_odors": "Fjern flekker og lukt fra kjæledyr",
      "after_school_care": "Skolefritidsordning",
      "all_hours_daycare": "Døgnåpen barnehage",
      "bilingual_daycare": "Tospråklig barnehage",
      "child_care_other": "Annen/annet",
      "drop_in_daycare": "Drop-in barnepass",
      "full_time_daycare": "Heltidsbarnehage",
      "in_home_daycare": "Hjemmebasert barnepass",
      "infant_programs": "Programmer for spedbarn",
      "part_time_daycare": "Deltidsbarnehage",
      "pre_kindergarten_programs": "Programmer for de yngste",
      "preschool_programs": "Førskoleprogrammer",
      "school_age_programs": "Programmer for skolealder",
      "special_needs_daycare": "Spesialbarnehage for barn med spesielle behov",
      "summer_daycare": "Sommerbarnehage",
      "toddler_programs": "Småbarnsprogrammer",
      "weekend_daycare": "Helgebarnehage",
      "chiropractor_acupuncture": "Akupunktur",
      "chiropractor_chiropractic": "Kiropraktikk",
      "chiropractor_massage_therapy": "Massasjeterapi",
      "chiropractor_other": "Annen/annet",
      "diagnosis": "Diagnose",
      "eastern_medicine": "Østlig medisin",
      "exercise_counseling": "Rådgivning om trening",
      "pain_management": "Smertebehandling",
      "physical_therapy": "Fysioterapi",
      "spinal_adjustments": "Tilpasninger av ryggraden",
      "sports_medicine": "Idrettsmedisin",
      "cleaner_other": "Annen/annet",
      "deep_clean": "Grundig rengjøring",
      "moving_clean": "Flytterengjøring",
      "office_clean": "Kontorrengjøring",
      "standard_clean": "Normalt renhold",
      "assignment_of_contract": "Overdragelse av kontrakt",
      "business_transactions_contract_lawyer": "Forretningstransaksjoner",
      "commercial_contracts_contract_lawyer": "Forretningskontrakter",
      "contract_dispute": "Konflikt om kontrakt",
      "contract_lawyer_other": "Annen/annet",
      "contract_negotiation": "Kontraktsforhandling",
      "contract_review": "Kontraktgjennomgang",
      "employment_contracts_contract_lawyer": "Arbeidskontrakter",
      "franchise_agreements": "Franchiseavtaler",
      "mergers_acquisitions_contract_lawyer": "Fusjoner og oppkjøp",
      "non_disclosure_agreements_contract_lawyer": "Avtaler om konfidensialitet",
      "partnership_agreements_contract_lawyer": "Partnerskapsavtaler",
      "power_of_attorney_contract_lawyer": "Fullmakt",
      "security_agreements": "Sikkerhetsavtaler",
      "warranties": "Garantier",
      "bathroom_countertops": "Baderomsbenkeplater",
      "bathroom_wall_panels": "Baderomsveggpaneler",
      "countertop_design": "Styling av benkeplate",
      "countertop_installation": "Montering av benkeplate",
      "countertop_pro_other": "Annen/annet",
      "fireplace_facade": "Peisfasade",
      "granite_countertops": "Granittbenkeplater",
      "kitchen_countertops": "Kjøkkenbenkeplater",
      "kitchen_wall_panels": "Kjøkkenvegger",
      "laminate_countertops": "Laminatbenkeplater",
      "marble_countertops": "Marmor benkeplater",
      "quartz_countertops": "Kvartsbenkeplater",
      "remodeling_countertop_pro": "Ombygging",
      "repair_maintenance_countertop_pro": "Reparasjon og vedlikehold",
      "stone_slab_countertops": "Steinplate benkeplater",
      "tile_countertops": "Flislagte benkeplater",
      "corporate_representation": "Bedriftsrepresentasjon",
      "criminal_immigration_defense": "Forsvar mot kriminell innvandring",
      "criminal_lawyer_other": "Annen/annet",
      "domestic_violence": "Vold i nære relasjoner",
      "drug_possession": "Eierskap av narkotika",
      "duis_reckless_driving": "Promillekjøring & hensynsløs kjøring",
      "expungement": "Sletting av rulleblad",
      "federal_crimes": "Føderale lovbrudd",
      "felonies": "Alvorlige forbrytelser",
      "petty_crimes_misdemeanors": "Småforbrytelser og forseelser",
      "restraining_orders": "Besøksforbud",
      "sex_offenses": "Seksuelle overgrep",
      "three_strikes_law": "Loven om tre treff",
      "dance_instructor_african": "Afrikansk",
      "dance_instructor_ballet": "Ballett",
      "dance_instructor_ballroom": "Ballsal",
      "dance_instructor_belly": "Mage",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Moderne",
      "dance_instructor_folk_traditional": "Folk og Klassisk",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Barneklasser",
      "dance_instructor_latin": "Latin",
      "dance_instructor_modern": "Moderne",
      "dance_instructor_other": "Annen/annet",
      "dance_instructor_tap": "Tappe",
      "dance_instructor_wedding": "Bryllup",
      "disability_hearings": "Høringer om uførhet",
      "disability_lawyer_other": "Annen/annet",
      "long_term_disability": "Langtidsuførhet",
      "short_term_disability": "Korttidsuførhet",
      "social_security_disability_insurance": "Trygdeforsikring for uføre",
      "ssa_claim_reconsideration": "Revurdering av SSA-søknad",
      "ssa_disability_appeals": "Klager på SSA-vedtak",
      "ssa_disability_applications": "SSA-søknad",
      "ssa_disability_benefits": "SSAs uføreytelser",
      "ssa_family_benefits": "SSA Familieytelser",
      "ssa_impairment_listings": "SSA-lister over uførhet",
      "supplemental_security_income": "Supplerende trygdeinntekt",
      "veterans_disability_benefits": "Uføretrygd for veteraner",
      "workers_compensation_disability_lawyer": "Arbeidsskadeforsikring",
      "behind_the_wheel_lessons": "Leksjoner bak rattet",
      "commercial_license_training": "Kurs i kommersiell lisens",
      "defensive_driving_lessons": "Kurs i defensiv kjøring",
      "drivers_education_classes": "Kjøreskoletimer",
      "driving_instructor_other": "Annen/annet",
      "manual_transmission_lessons": "Leksjoner i manuell overføring",
      "motorcycle_lessons": "Motorsykkelleksjoner",
      "traffic_school": "Trafikkskole",
      "dui_dwi_dui_lawyer": "PROMILLEKJØRING",
      "dui_injuries_dui_lawyer": "Fyllekjøring med personskade",
      "dui_lawyer_other": "Annen/annet",
      "dui_with_accident": "Fyllekjøring med ulykke",
      "felony_dui": "Grov fyllekjøring",
      "invalid_tests": "Ugyldige tester",
      "multiple_offenses": "Flere overtredelser",
      "reckless_driving_dui_lawyer": "Uforsiktig kjøring",
      "underage_dui": "Mindreårig fyllekjøring",
      "electric_car_charger": "Installer ladestasjon for elbil",
      "electrician_other": "Annen/annet",
      "electrician_remodeling": "Ombygging",
      "install_fan": "Installer vifte",
      "install_ground_wire": "Installer jordingsledning",
      "install_light_fixtures": "Installer lysarmaturer",
      "install_outdoor_lighting": "Installer utendørsbelysning",
      "install_outlets_switches": "Installer stikkontakter eller brytere",
      "install_security_system": "Installer sikkerhetssystem",
      "relocate_outlets_switches": "Flytt stikkontakter eller brytere",
      "repair_fan": "Reparere vifte",
      "repair_light_fixtures": "Reparere lystarmaturer",
      "repair_outlets_switches": "Reparere uttak eller brytere",
      "repair_panel": "Reparere panel",
      "replace_upgrade_panel": "Skift ut eller oppgrader panelet",
      "restore_power": "Gjenopprett strøm",
      "energy_efficiency_pro_other": "Annen/annet",
      "charitable_giving": "Veldedig donasjon",
      "contests_litigation": "Tvister / Rettssaker",
      "deeds": "Handlinger",
      "estate_lawyer_other": "Annen/annet",
      "estate_planning_lawyer": "Eiendomsplanlegging",
      "guardianship_estate_lawyer": "Vokteransvar",
      "medical_power_of_attorney": "Fullmakt av medisinske beslutninger",
      "power_of_attorney_estate_lawyer": "Fullmakt",
      "probate_estate_lawyer": "Advokat for skiftebo",
      "trusts": "Stiftelser",
      "wills": "Testamenter",
      "anniversary_planner": "Årsdag",
      "baby_shower_planner": "Babyselskap",
      "bar_and_bat_mitzvah_planner": "Bar og bat mitzva",
      "birthday_party": "Bursdagsfest",
      "children_party": "Barneselskap",
      "corporate_and_conference_planner": "Bedrift og konferanse",
      "event_planner_other": "Annen/annet",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Religiøs begivenhet",
      "retirement_party": "Avskjedsfest",
      "school_event": "Skolearrangement",
      "theme_party": "Temafest",
      "wedding_and_engagement_planner": "Bryllup og forlovelse",
      "adoption": "Adopsjon",
      "child_support": "Barnebidrag",
      "contested_divorce": "Omstridt skilsmisse",
      "debt_division": "Gjeldsfordeling",
      "family_lawyer_other": "Annen/annet",
      "guardianship_family_lawyer": "Vokteransvar",
      "mediation_family_lawyer": "Mekling",
      "modifications_of_orders": "Endring av ordre",
      "parent_timesharing": "Foreldretidsdeling",
      "paternity": "Paternitet",
      "prenuptial_postnuptial_agreements": "Ektepakts- og ekteskapsavtaler",
      "probate_family_lawyer": "Skifte",
      "property_divisions": "Eiendomsfordeling",
      "protective_orders_domestic_violence_issues": "Besøksforbud",
      "spousal_support_alimony": "Ektefellebidrag og ektefelleunderstøttelse",
      "uncontested_divorce": "Ubestridt skilsmisse",
      "custom_construction": "Tilpasset konstruksjon",
      "fence_design": "Styling av gjerde",
      "fencing_other": "Annen/annet",
      "installation_fencing_pro": "Gjerdeinstallasjon",
      "repairs_maintenance_fencing_pro": "Reparasjoner og vedlikehold",
      "education_savings": "Spare til utdanning",
      "estate_financial_planning": "Eiendomsplanlegging",
      "financial_planning": "Finansiell planlegging",
      "financial_planning_other": "Annen/annet",
      "home_purchase": "Kjøp av bolig",
      "insurance": "Forsikring",
      "investment_advising": "Investeringsrådgivning",
      "retirement_savings": "Pensjonering",
      "tax_planning": "Avgiftsplanlegging",
      "advanced_cardiac_life_support": "Avansert hjertelivredning",
      "aed_defibrillator": "AED - Defibrillator",
      "basic_life_support": "Grunnleggende livredning",
      "cpr": "HLR",
      "first_aid": "Førstehjelp",
      "first_aid_trainer_other": "Annen/annet",
      "pediatric_advanced_life_support": "Pediatrisk avansert livreddende behandling",
      "pediatric_cpr_first_aid": "Pediatrisk HLR og førstehjelp",
      "pet_cpr_first_aid": "HLR og førstehjelp for kjæledyr",
      "wilderness_first_aid": "Førstehjelp i villmarken",
      "baseboards": "Gulvlister",
      "carpet": "Teppe",
      "flooring_other": "Annen/annet",
      "hardwood": "Hardved",
      "installation_flooring_pro": "Legge gulv",
      "marble": "Marmor",
      "polishing": "Gulvpolering",
      "refinishing": "Gulvsliping og lakkering",
      "repair_maintenance_flooring_pro": "Reparasjon av gulv og Vedlikehold",
      "stair_flooring": "Trappegulvbelegg",
      "tile": "Flis",
      "wood_floor_sanding": "Gulvsliping av tre",
      "basement_waterproofing": "Tetting av kjellere",
      "crawl_spaces": "Fundament i krypkjelleren",
      "foundation_drainage": "Grunnleggende drenering",
      "foundation_installation": "Installasjon av grunnmur",
      "foundation_pro_other": "Annen/annet",
      "foundation_raising": "Fundamentheving",
      "repairs_maintenance_foundation_pro": "Reparasjoner og vedlikehold",
      "slab_foundation": "Platefundament",
      "steel_pier_pilings": "Stålpæler for brygge",
      "water_moisture_control": "Vann- og fuktighetskontroll",
      "burials": "Begravelser",
      "caskets": "Kister",
      "cremation": "Kremasjon",
      "funeral_home_flowers": "Blomster",
      "funeral_home_other": "Annen/annet",
      "funeral_home_transportation_transfers": "Transport og overføringer",
      "funeral_home_veteran_services": "Veterantjenester",
      "funerals": "Begravelser",
      "gravestones": "Gravsteiner",
      "grief_services": "Sørgetjenester",
      "memorials": "Minnesmerker",
      "urns": "Urner",
      "garage_door_other": "Annen/annet",
      "general_maintenance": "Generelt vedlikehold",
      "install_garage_door": "Installer garasjeport",
      "install_opener": "Installer åpneren",
      "repair_cables": "Reparasjon av kabler",
      "repair_garage_door": "Reparere garasjeport",
      "repair_gate": "Reparasjonsport",
      "repair_rollers_tracks": "Reparere ruller og spor",
      "replace_door_panels": "Bytte ut dørpaneler",
      "replace_opener": "Bytte ut åpneren",
      "replace_springs": "Bytte ut fjærer",
      "accessory_buildings": "Tilhørende bygninger",
      "bathroom_remodel": "Baderomsoppussing",
      "decks_patio": "Terrasser og uteplass",
      "exterior_finishing": "Utvendig finish",
      "foundations_concrete": "Fundamenter og betong",
      "general_contractor_commercial_projects": "Kommersielle prosjekter",
      "general_contractor_other": "Annen/annet",
      "home_addition": "Hjemtillegg",
      "home_building": "Boligbygging",
      "home_remodel_renovation": "Ombygging og renovering av hjemmet",
      "interior_finishing": "Innvendig finish",
      "kitchen_remodel": "Kjøkkenoppussing",
      "roofing": "Taktekking",
      "assemble_furniture": "Montere møbler",
      "clean_gutters": "Rengjør takrenner",
      "handyman_other": "Annen/annet",
      "install_drywall": "Installere gipsplater",
      "install_flooring": "Installere gulv",
      "install_tile": "Installer flis",
      "install_water_fixtures": "Installer vannarmaturer",
      "mount_tv": "Monter TV",
      "paint_indoors": "Maling innendørs",
      "paint_outdoors": "Maling utendørs",
      "repair_drywall": "Reparere gipsplater",
      "repair_flooring": "Reparere gulv",
      "repair_water_fixtures": "Reparere vannarmaturer",
      "replace_tile": "Erstatt flis",
      "buyer_seller_inspection": "Kjøper-selger-inspeksjon",
      "commercial_properties": "Kommersielle egenskaper",
      "fire_safety": "Brannsikkerhet",
      "fireplace_chimney": "Peis og skorstein",
      "full_home_inspection": "Fullstendig boliginspeksjon",
      "home_inspector_electrical": "Elektrisk",
      "home_inspector_foundation": "Grunnlag",
      "home_inspector_hvac": "VVS",
      "home_inspector_mold": "Mugg",
      "home_inspector_new_construction": "Nybygg",
      "home_inspector_other": "Annen/annet",
      "home_inspector_plumbing": "Rørleggerarbeid",
      "home_inspector_roof": "Tak",
      "home_inspector_structural": "Strukturell",
      "home_warranty": "Hjemmegaranti",
      "water_testing": "Vanntesting",
      "well_or_septic_system": "Brønn eller septikksystem",
      "wood_insects": "Tre og insekter",
      "access_control": "Adgangskontroll",
      "alarm_systems": "Alarmsystemer",
      "commercial_security_systems": "Kommersielle sikkerhetssystemer",
      "fire_smoke_detection": "Brann- og røykdeteksjon",
      "home_security_doors": "Dører",
      "home_security_locks": "Låser",
      "home_security_other": "Annen/annet",
      "home_security_windows": "Vinduer",
      "monitoring_services": "Overvåkingstjenester",
      "residential_security_systems": "Sikkerhetssystemer for boliger",
      "smart_home_integration": "Integrering av smarthjem",
      "video_surveillance": "Videoovervåking",
      "audio_video_installation": "Audio- og videoinstallasjon",
      "commercial_projects": "Kommersielle prosjekter",
      "home_theater_design": "Design av hjemmekinoanlegg",
      "home_theater_lighting": "Belysning",
      "home_theater_other": "Annen/annet",
      "home_theater_smart_home_integration": "Integrering av smarthjem",
      "install_tv": "Installer TV",
      "network_it_services": "System- og IT-tjenester",
      "outdoor_installations": "Utendørs installasjoner",
      "soundproofing": "Lydisolering",
      "whole_house_audio_video": "Audio og video for hele huset",
      "ac_maintenance": "AC-vedlikehold",
      "clean_ducts_vents": "Rengjør kanaler & ventiler",
      "ductless_heating_and_ac_services": "Kanalfri oppvarming og klimatjenester",
      "heating_maintenance": "Oppvarmingsvedlikehold",
      "hvac_maintenance": "Vedlikehold av VVS",
      "hvac_other": "Annen/annet",
      "install_ac": "Installer klimaanlegg",
      "install_ducts_vents": "Installer kanaler og ventiler",
      "install_heating_system": "Installere varmesystem",
      "install_thermostat": "Installer termostat",
      "repair_ac": "Reparere klimaanlegg",
      "repair_ducts_vents": "Reparasjon av kanaler og ventiler",
      "repair_heating_system": "Reparasjon av varmesystem",
      "repair_hvac": "Reparere VVS",
      "repair_thermostat": "Reparasjon av termostat",
      "asylum": "Asyl",
      "citizenship": "Statsborgerskap",
      "deportation": "Utvisning",
      "family_based_immigration": "Familiebasert innvandring",
      "green_card": "Grønt kort",
      "immigration_lawyer_other": "Annen/annet",
      "investment_visa": "Investeringstillatelse",
      "outbound_work_permits": "Utgående arbeidstillatelser",
      "student_visa": "Studentvisum",
      "visitor_visa": "Besøksvisum",
      "work_visa": "Arbeidsvisum",
      "appliance_selection": "Apparatvalg",
      "cabinetry_molding_hardware_design": "Styling av skap og maskinvare",
      "decorating": "Dekorering",
      "door_design": "Styling av dør",
      "exterior_building_design": "Utvendig bygningsdesign",
      "flooring_selection": "Gulvvalg",
      "interior_designer_other": "Annen/annet",
      "landscaping_design": "Landskapsutforming",
      "lighting_design": "Belysningsdesign",
      "multifamily_housing_design": "Design av flerfamilieboliger",
      "room_planning": "Romplanlegging",
      "stone_brick_stucco_design": "Stein, murstein, & stukkaturstyling",
      "window_design": "Vindusdesign",
      "advertisements": "Reklame",
      "copyright": "Opphavsrett",
      "export_control": "Eksportkontroll",
      "franchises": "Franchiser",
      "international_ip": "Internasjonal IP",
      "ip_lawyer_other": "Annen/annet",
      "ip_strategy": "IP-strategi",
      "ip_transactions": "IP-transaksjoner",
      "licensing": "Lisensiering",
      "litigation_ip_lawyer": "Søksmål",
      "non_disclosure_agreements_ip_lawyer": "Avtaler om konfidensialitet",
      "patents": "Patenter",
      "technology_transfer": "Teknologioverføring",
      "trade_secrets": "Forretningshemmeligheter",
      "trademarks": "Varemerker",
      "appliance_removal": "Fjerning av hvitevarer",
      "construction_waste_removal": "Fjerning av bygningsavfall",
      "donation_pickup": "Henting av donasjoner",
      "electronic_waste_removal": "Fjerning av elektronisk avfall",
      "furniture_removal": "Flytting av møbler",
      "general_junk_removal": "Generell søppelfjerning",
      "hazardous_waste_removal": "Fjerning av farlig avfall",
      "house_garage_cleanout": "Rydding av hus/garasje",
      "junk_removal_other": "Annen/annet",
      "yard_waste_removal": "Fjerning av hageavfall",
      "employment_contracts_labor_lawyer": "Arbeidskontrakter",
      "employment_law_labor_lawyer": "Arbeidsjus",
      "exempt_employee_status": "Status som fritatt ansatt",
      "labor_law": "Arbeidsjus",
      "labor_lawyer_other": "Annen/annet",
      "labor_negotiations": "Forhandlinger om arbeidsvilkår",
      "privacy_rights": "Personvernrettigheter",
      "sexual_harassment": "Seksuell trakassering",
      "unpaid_overtime": "Ubetalt overtid",
      "whistle_blowing": "Varsling",
      "workers_compensation_labor_lawyer": "Arbeidsskadeforsikring",
      "wrongful_termination": "Urettmessig oppsigelse",
      "artificial_turf_installation": "Installasjon av kunstgress",
      "concrete_masonry": "Betongmur",
      "driveway_landscaping": "Beplantning av innkjørsel",
      "garden_decorations": "Hagedekorasjoner",
      "grading_resloping": "Gradering og resloping",
      "hardscapes": "Hagemøbler",
      "landscape_design": "Landskapsdesign",
      "landscape_installations": "Landskapsinstallasjoner",
      "landscaper_other": "Annen/annet",
      "outdoor_steps": "Utendørs trappetrinn",
      "outdoor_water_feature": "Utendørs vanninstallasjoner",
      "paving_driveway_walkway": "Brolegging av innkjørsel eller gangsti",
      "retaining_walls": "Støttemurer",
      "sidewalk_walkway_landscaping": "Landskapsarkitektur for gangveier",
      "sod_seeding": "Torv og såing",
      "stone_masonry": "Steinmurverk",
      "arabic": "Arabisk",
      "english": "English",
      "french": "Fransk",
      "german": "Tysk",
      "hebrew": "Hebraisk",
      "italian": "Italiensk",
      "japanese": "Japansk",
      "korean": "Koreansk",
      "language_instructor_other": "Annen/annet",
      "mandarin": "Mandarin",
      "portuguese": "Portugisisk",
      "russian": "Russisk",
      "sign_language": "Tegnspråk",
      "spanish": "Spansk",
      "irrigation_system_repair_maintenance": "Reparasjon/vedlikehold av vanningssystem",
      "lawn_care_other": "Annen/annet",
      "lawn_mowing_maintenance": "Gressklipping / Vedlikehold",
      "lawn_pest_control": "Skadedyrkontroll for plener",
      "mulching": "Dekkemateriale",
      "seeding": "Såing",
      "sod_installation": "Legging av ferdigplen",
      "weed_control": "Ugressbekjempelse",
      "yard_cleanup": "Opprydding av gårdsplass",
      "appeals": "Appeller",
      "case_assessment_litigation_lawyer": "Saksvurdering",
      "civil_litigation": "Sivilprosess",
      "commercial_litigation": "Forretningsjuridiske tvister",
      "contracts_and_agreements": "Kontrakter og avtaler",
      "criminal_litigation": "Straffesaker",
      "litigation_lawyer_other": "Annen/annet",
      "mediation_litigation_lawyer": "Mekling",
      "settlements": "Oppgjør",
      "building_lockout": "Bygningsutestengelse",
      "copy_building_key": "Kopiere bygningsnøkler",
      "copy_vehicle_key": "Kopier bilnøkkel",
      "install_hardware": "Installer maskinvare",
      "locksmith_other": "Annen/annet",
      "new_key_fob": "Ny nøkkelbrikke",
      "rekey_lock": "Ny nøkkel til lås",
      "repair_hardware": "Reparere maskinvare",
      "vehicle_lockout": "Kjøretøyutlåsing",
      "consent_issues": "Samtykkeproblemer",
      "diagnosis_errors": "Feil ved diagnose",
      "malpractice_lawyer_other": "Annen/annet",
      "medical_negligence": "Medisinsk uaktsomhet",
      "treatment_errors": "Behandlingsfeil",
      "massage_center_other": "Annen/annet",
      "massage_school_advanced_neuromuscular_therapy": "Avansert nevromuskulær terapi",
      "massage_school_business_and_ethics": "Bedrift og etikk",
      "massage_school_clinical_therapies": "Kliniske behandlinger",
      "massage_school_continuing_education": "Videreutdanning",
      "massage_school_deep_tissue_massage": "Dypvevsmassasje",
      "massage_school_energetics": "Energi",
      "massage_school_hydrotherapy": "Hydroterapi",
      "massage_school_lymphatic_massage": "Lymfatisk massasje",
      "massage_school_online_massage_therapy": "Massasjeterapi på nett",
      "massage_school_other": "Annen/annet",
      "massage_school_prenatal_massage": "Gravidmassasje",
      "massage_school_sports_massage": "Sportsmassasje",
      "massage_school_student_massage_clinic": "Studentmassasjeklinikk",
      "massage_school_swedish_massage": "Svensk massasje",
      "massage_theory": "Massasjeteori",
      "massage_therapy_training": "Utdanning i massasjeterapi",
      "in_state_move": "Flytting innenlands",
      "local_move": "Lokal flytting",
      "mover_other": "Annen/annet",
      "moving_junk_removal": "Fjerning av avfall",
      "moving_storage": "Lagring",
      "out_of_state_move": "Flytting utenlands",
      "oversized_item_move": "Flytting av overdimensjonerte gjenstander",
      "packing_unpacking": "Pakking / utpakking",
      "senior_move": "Flytting av eldre",
      "vehicle_transport": "Kjøretøytransport",
      "cardiac_care": "Hjerteomsorg",
      "general_medical_care": "Generell medisinsk behandling",
      "hospice": "Etterpleie",
      "iv_therapy": "IV-behandling",
      "nursing_home_meal_services": "Måltidstjenester",
      "nursing_home_memory_care": "Minnepleie",
      "nursing_home_other": "Annen/annet",
      "nursing_home_pain_management": "Smertebehandling",
      "nursing_home_rehabilitation_services": "Rehabiliteringstjenester",
      "nursing_home_wellness_programs": "Velværeprogrammer",
      "outpatient_rehabilitation": "Poliklinisk rehabilitering",
      "post_hospital_care": "Pleie etter sykehusopphold",
      "respiratory_and_pulmonary_care": "Respirasjons- og lungepleie",
      "senior_activity_programs": "Senioraktivitetsprogrammer",
      "short_term_rehabilitation": "Korttidsrehabilitering",
      "wound_care": "Sårpleie",
      "exterior_painting": "Utvendig maling",
      "interior_painting": "Innvendig maling",
      "paint_cabinets": "Maling av skap",
      "paint_doors": "Mal dører",
      "painter_other": "Annen/annet",
      "repair_water_damage": "Reparasjon av vannskader",
      "staining": "Farging",
      "assault_battery": "Angrep og vold",
      "auto_accidents": "Bilulykker",
      "bicycle_accidents": "Sykkelulykker",
      "catastrophic_injuries": "Katastrofale skader",
      "dog_bites": "Hundebitt",
      "dui_injuries_personal_injury_lawyer": "Skader fra promillekjøring",
      "medical_malpractice": "Medisinsk feilbehandling",
      "motorcycle_accidents": "Motorsykkelulykker",
      "pain_suffering": "Smerte & lidelse",
      "pedestrian_accidents": "Fotgjengerulykker",
      "personal_injury_lawyer_other": "Annen/annet",
      "product_liability": "Produktansvar",
      "slip_fall": "Skli og Fall",
      "uninsured_motorist_claims": "Bilforsikringskrav",
      "workers_compensation_personal_injury_lawyer": "Arbeidsskadeforsikring",
      "wrongful_death": "Feilaktig død",
      "aerobics": "Aerobic",
      "athletic_performance": "Idrettslige prestasjoner",
      "circuit_training": "Kretstrening",
      "endurance": "Utholdenhet",
      "fitness_assessment": "Vurdering av kondisjon",
      "hiit": "HIIT",
      "nutritional_counseling": "Ernæringsrådgivning",
      "personal_trainer_other": "Annen/annet",
      "strength_conditioning": "Styrke og kondisjon",
      "weight_loss": "Vekttap",
      "yoga": "Yoga",
      "ants": "Maur",
      "bed_bugs": "Veggedyr",
      "bees": "Bier",
      "cockroaches": "Kakerlakker",
      "fleas_or_mites": "Lopper eller midd",
      "hornets_or_wasps": "Gullveps eller veps",
      "mosquitoes": "Mygg",
      "pest_control_other": "Annen/annet",
      "pest_inspection": "Inspeksjon",
      "rodents": "Gnagere",
      "spiders": "Edderkopper",
      "termites": "Termitter",
      "wildlife": "Dyreliv",
      "pet_adoption_birds": "Fugler",
      "pet_adoption_cats": "Katter",
      "pet_adoption_dogs": "Hunder",
      "pet_adoption_farm_animals": "Gårdsdyr",
      "pet_adoption_fish": "Fisk",
      "pet_adoption_other": "Annen/annet",
      "pet_adoption_reptiles": "Reptiler",
      "pet_adoption_small_mammals": "Liten pattedyr",
      "pet_adoption_special_needs_animals": "Dyr med spesielle behov",
      "cat_boarding": "Kattehotell",
      "cat_grooming": "Kattestell",
      "cat_sitting_in_home": "Kattepass (i hjemmet)",
      "dog_boarding": "Hundepensjon",
      "dog_boarding_with_training": "Hundepensjonat med trening",
      "dog_daycare": "Hundebarnehage",
      "dog_grooming": "Hundestell",
      "dog_sitting_in_home": "Hundepass (i hjemmet)",
      "dog_training": "Hundetrening",
      "dog_walking": "Hundelufting",
      "other_pet_boarding": "Annen dyreinnkvartering",
      "other_pet_daycare": "Annen/annet barnehage for kjæledyr",
      "other_pet_grooming": "Annen pleie av kjæledyr",
      "other_pet_sitting_in_home": "Annen dyrepass (i hjemmet)",
      "pet_boarding_other": "Annen/annet",
      "cat_bathing": "Kattebading",
      "cat_ear_cleaning": "Rensing av katteører",
      "cat_grooming_and_styling": "Kattestell og styling",
      "cat_nail_trimming": "Kattens negleklipping",
      "dog_anal_gland_expression": "Hundens analkjerteltømming",
      "dog_bathing_and_blow_dry": "Hundebad og føning",
      "dog_ear_cleaning": "Rensing av hundeører",
      "dog_flea_and_tick_treatment": "Loppe- og flåttbehandling for hund",
      "dog_full_service_grooming": "Fullservice hundepleie",
      "dog_grooming_and_styling": "Hundestell og styling",
      "dog_nail_trimming": "Klipping av hundens klør",
      "dog_teeth_brushing": "Rensing av hundetenner",
      "pet_grooming_other": "Annen/annet",
      "aggressive_dog_training": "Aggressiv hundetrening",
      "behavior_modification": "Atferdsmodifikasjon",
      "obedience_training": "Lydighetstrening",
      "offleash_training": "Kurs uten bånd",
      "pet_trainer_other": "Annen/annet",
      "puppy_training": "Valpeopplæring",
      "service_animal_training": "Opplæring av servicehund",
      "sport_trick_training": "Sport- eller triksopplæring",
      "training_other_animals": "Opplæring for andre dyr",
      "corporate_photo": "Bedrift",
      "events_and_parties_photo": "Selskaper og fester",
      "family_and_group_photo": "Familie og gruppe",
      "headshots_and_portraits": "Portrettbilder",
      "individual_photo": "Individuell",
      "maternity_and_newborn_photo": "Mødre og nyfødte",
      "photographer_other": "Annen/annet",
      "product_photo": "Produkt",
      "real_estate_photo": "Eiendom",
      "school_portraits": "Skoleportretter",
      "wedding_and_engagement_photo": "Bryllup og forlovelse",
      "find_leak": "Oppdage og reparere lekkasje",
      "install_faucet": "Installere kran",
      "install_garbage_disposal": "Installere avfallskvern",
      "install_shower": "Installere dusj",
      "install_toilet": "Installere toalett",
      "install_water_heater": "Installere varmtvannsbereder",
      "plumbing_other": "Annen/annet",
      "repair_faucet": "Reparere kran",
      "repair_garbage_disposal": "Reparere avfallskvern",
      "repair_outdoor_systems": "Reparere utendørssystemer",
      "repair_pipe": "Reparere rør",
      "repair_sewer": "Reparere avløp",
      "repair_shower": "Reparere dusj",
      "repair_toilet": "Reparere toalett",
      "repair_water_heater": "Reparere varmtvannsbereder",
      "unclog_drain": "Fjern blokkering i avløpet",
      "commercial_pool_cleaning_maintenance": "Rensing og vedlikehold av kommersielle svømmebassenger",
      "equipment_maintenance_repair": "Reparasjon og vedlikehold av utstyr",
      "one_time_pool_cleaning": "Engangsbassengrengjøring",
      "ongoing_pool_cleaning": "Løpende rengjøring av bassenget",
      "pool_cleaner_other": "Annen/annet",
      "pool_cleaner_water_features": "Vannfunksjoner",
      "seasonal_opening_closing": "Sesongåpning og -lukking",
      "spa_hot_tub_cleaning": "Rensing av spa og boblebad",
      "spa_hot_tub_repairs": "Reparasjoner av spa og boblebad",
      "tile_pool_wall_cleaning": "Rensing av fliser og bassengvegger",
      "water_testing_balancing": "Vanntesting og balansering",
      "jetted_lap_pools": "Bassenger med jetstrøm for svømming",
      "pool_construction": "Bassengkonstruksjon",
      "pool_contractor_commercial_projects": "Kommersielle prosjekter",
      "pool_contractor_custom_designs": "Tilpassede design",
      "pool_contractor_other": "Annen/annet",
      "pool_contractor_renovation": "Renovering",
      "pool_contractor_repair_cracks": "Reparer sprekker",
      "pool_contractor_repair_tile": "Reparere fliser",
      "pool_contractor_resurfacing": "Gjenopprette overflate",
      "pool_contractor_water_features": "Vannfunksjoner",
      "pool_hot_tub_equipment": "Utstyr for basseng og boblebad",
      "spa_hot_tub_installation": "Installasjon av spa og boblebad",
      "bilingual_programs": "Tospråklige programmer",
      "early_preschool": "Tidlig barnehage",
      "full_day_preschool": "Heldagsbarnehage",
      "half_day_preschool": "Halvdagsbarnehage",
      "kindergarten_classes": "Barnehageklasser",
      "montessori_programs": "Montessori-programmer",
      "play_based_preschool": "Lekbasert barnehage",
      "preschool_infant_programs": "Programmer for spedbarn",
      "preschool_other": "Annen/annet",
      "reggio_emilia_preschool": "Reggio Emilia-barnehage",
      "special_needs_programs": "Programmer for spesialbehov",
      "summer_camp": "Sommerleir",
      "waldorf_preschool": "Waldorfbarnehage",
      "psychologist_other": "Annen/annet",
      "buyer_agent": "Kjøperens representant",
      "first_time_home_buyer": "Første gangs boligkjøper",
      "foreclosed_properties": "Tvangssalgseiendommer",
      "luxury_properties": "Luksuseiendommer",
      "new_construction": "Nybygg",
      "property_management": "Eiendomsadministrasjon",
      "real_estate_agent_other": "Annen/annet",
      "relocation": "Relokalisering",
      "rentals": "Leieavtaler",
      "sellers_agent": "Selgers representant",
      "commercial_real_estate": "Kommersiell eiendom",
      "easements": "Servitutter",
      "encroachment": "Inntrenging",
      "foreclosure_real_esate_lawyer": "Tvangsauksjon",
      "landlord_tenant_law": "Utleier- og leietakerjus",
      "litigation_real_estate_lawyer": "Søksmål",
      "mortgage_lending_law": "Boliglån og utlånslov",
      "neighbor_hoa_disputes": "Nabo- og borettslagstvister",
      "property_damage": "Skade på eiendom",
      "purchase_agreements": "Kjøpeavtaler",
      "real_estate_contracts_transactions": "Eiendomstransaksjoner",
      "real_estate_lawyer_other": "Annen/annet",
      "residential_real_estate": "Boligeiendom",
      "title_services": "Dokumenttjenester",
      "trespassing": "Ulovlig inntrenging",
      "rehab_other": "Annen/annet",
      "attic_venting": "Loftsventilasjon",
      "gutter_installation": "Installasjon av takrenner",
      "gutter_repair": "Reparasjon av takrenner",
      "roof_inspection": "Takinspeksjon",
      "roof_installation": "Takinstallasjon",
      "roof_repair": "Takreparasjon",
      "roofer_other": "Annen/annet",
      "skylight_installation": "Installasjon av takvinduer",
      "skylight_repair": "Reparasjon av takvindu",
      "storm_wind_damage_roof_repair": "Reparasjon av takskader",
      "sewage_cleaning": "Rensing",
      "sewage_excavation": "Utgraving",
      "sewage_inspection": "Inspeksjon",
      "sewage_installation": "Installasjon",
      "sewage_locating": "Lokalisering",
      "sewage_maintenance_repairs": "Vedlikehold og reparasjoner",
      "sewage_pro_other": "Annen/annet",
      "sewage_pumping": "Pumping",
      "sewage_removal_demolition": "Fjerning eller demontering",
      "remodeling_siding_pro": "Ombygging",
      "repair_maintenance_siding_pro": "Reparasjon og vedlikehold",
      "siding_installation": "Montering av kledning",
      "siding_pro_other": "Annen/annet",
      "siding_removal": "Fjerning av kledning",
      "smart_home_other": "Annen/annet",
      "commercial_snow_removal": "Måking for næringslivet",
      "residential_plowing": "Måking for boliger",
      "residential_shoveling_blowing": "Måking og snøfjerning for boliger",
      "salt_sand_deicing": "Salt, sand og avisning",
      "snow_relocation": "Snørelokasjon",
      "snow_removal_other": "Annen/annet",
      "body_polish": "Hoveddelpolering",
      "body_wrap": "Hoveddelinnpakning",
      "facial": "Ansiktsbehandling",
      "hydrotherapy": "Hydroterapi",
      "manicure": "Manikyr",
      "massage": "Massasje",
      "pedicure": "Pedikyr",
      "peels": "Peeling",
      "spa_other": "Annen/annet",
      "spa_packages": "Spa-pakker",
      "tanning": "Soling",
      "waxing": "Voksing",
      "civil_tax_litigation": "Sivil rettstvist om skatt",
      "corporate_taxes": "Bedriftsskatt",
      "criminal_tax_litigation": "Straffesak om skatteunndragelse",
      "estate_tax_planning": "Planlegging av eiendomsavgift",
      "failure_to_file": "Manglende dokument",
      "innocent_spouse_relief": "Lettelse for uskyldig ektefelle",
      "international_tax_services": "Internasjonale skattetjenester",
      "irs_tax_problems": "Skatteproblemer med IRS",
      "non_collectible_status": "Status som ikke kan inndrives",
      "offer_in_compromise": "Tilbud om forlik",
      "tax_audits": "Avgiftsrevisjoner",
      "tax_lawyer_other": "Annen/annet",
      "tax_liens_levies": "Skatteavgift og -gebyr",
      "tax_planning_lawyer": "Skatteplanlegging",
      "tax_relief": "Skattelette",
      "accounting_support": "Kundestøtte for regnskap",
      "business_incorporation_restructuring": "Inkorporering og omstrukturering",
      "cryptocurrency_taxes": "Skatter på kryptovaluta",
      "irs_audit_representation": "IRS-revisjonsbistand",
      "irs_filing": "IRS-innlevering",
      "irs_problem_consulting": "Rådgivning om IRS-skatteproblemer",
      "new_business_services": "Nye virksomhetstjenester",
      "payroll_support": "Lønningsstøtte",
      "tax_planning_tax_specialist": "Skatteplanlegging",
      "tax_preparation": "Skatteforberedelse",
      "tax_problem_consulting_tax_specialist": "Konsulenttjenester for skatteproblemer",
      "tax_specialist_other": "Annen/annet",
      "therapist_other": "Annen/annet",
      "battery_service": "Voldstjeneste",
      "car_towing": "Bilberging",
      "fuel_delivery": "Drivstoffleveranse",
      "local_hauling": "Lokal frakt",
      "long_distance_hauling": "Langdistansefrakt",
      "motorcycle_towing": "Motorsykkelberging",
      "special_vehicle_towing": "Tauing av spesialkjøretøy",
      "tire_change": "Dekkbytte",
      "towing_other": "Annen/annet",
      "case_assessment_traffic_lawyer": "Saksvurdering",
      "cdl_traffic_ticket": "CDL-trafikkbillett",
      "dui_dwi_traffic_lawyer": "Fyllekjøring",
      "fixit_ticket": "Reparasjonsforespør",
      "parking_ticket": "Parkeringsbot",
      "reckless_driving_traffic_lawyer": "Uforsiktig kjøring",
      "red_light_ticket": "Bøter ved rødt lys",
      "speeding_ticket": "Fartsbot",
      "suspended_license": "Suspendert førerkort",
      "traffic_lawyer_other": "Annen/annet",
      "traffic_ticket": "Trafikkbot",
      "cabling_and_bracing": "Kabling og avstivning",
      "stump_removal": "Fjerning av stubber",
      "tree_planting": "Treetilplanting",
      "tree_removal": "Fjerning av trær",
      "tree_service_other": "Annen/annet",
      "tree_transplanting": "Tretransplantasjon",
      "tree_trimming_and_pruning": "Beskjæring og trimming av trær",
      "tutor_computer_science": "Datavitenskap",
      "tutor_foreign_languages": "Fremmedspråk",
      "tutor_geography": "Geografi",
      "tutor_government_and_economics": "Offentlig forvaltning og økonomi",
      "tutor_history": "Historikk",
      "tutor_homework_help": "Leksehjelp",
      "tutor_math": "Matematikk",
      "tutor_other": "Annen/annet",
      "tutor_reading_and_writing": "Lesing og skriving",
      "tutor_science": "Vitenskap",
      "tutor_special_education": "Spesialutdanning",
      "tutor_test_pre_college_entrance": "Testforberedelser: Opptak til høyskole",
      "tutor_test_prep_grad_school_entrance": "Testforberedelse: Opptak til høyere utdanning",
      "tutor_test_prep_k8": "Testforberedelser: K-8",
      "area_rug_cleaning": "Rensing av teppeløper",
      "drapery_and_blind_cleaning": "Rensing av draperier og persienner",
      "leather_cleaning": "Rensing av skinn",
      "mattress_cleaning": "Madrassrengjøring",
      "upholstery_cleaner_other": "Annen/annet",
      "upholstery_cleaning": "Rensing av møbeltrekk",
      "upholstery_water_damage_cleanup": "Rensing etter vannskader",
      "bird_exotic_animal_care": "Pleie av fugl og eksotisk dyr",
      "farm_barn_animal_care": "Stell av gårds- og fjøsdyr",
      "microchipping": "Mikrochipmerking",
      "veterinarian_allergies": "Allergier",
      "veterinarian_behavior_counseling": "Atferdsrådgivning",
      "veterinarian_dental_care": "Tannpleie",
      "veterinarian_dermatology": "Dermatologi",
      "veterinarian_emergency_care": "Nødhjelp",
      "veterinarian_end_of_life_care": "Omsorg ved livets slutt",
      "veterinarian_examinations": "Undersøkelser",
      "veterinarian_nutrition_counseling": "Ernæringsrådgivning",
      "veterinarian_other": "Annen/annet",
      "veterinarian_preventive_care": "Forebyggende tiltak",
      "veterinarian_spay_neuter": "Sterilisere eller kastrere",
      "veterinarian_surgery": "Kirurgi",
      "veterinarian_vaccinations": "Vaksinasjoner",
      "aerial_videography": "Luftvideografi",
      "documentary_video_production": "Dokumentarproduksjon",
      "family_video_production": "Familievideoproduksjon",
      "live_streaming": "Direkte strømming",
      "photography": "Fotografi",
      "product_demonstrations": "Produktdemonstrasjon",
      "promotional_video_production": "Produksjon av reklamevideoer",
      "real_estate_video_production": "Videoproduksjon for eiendomsmegling",
      "special_event_video_production": "Videoproduksjon for spesielle arrangementer",
      "video_editing": "Video",
      "videographer_other": "Annen/annet",
      "voice_overs": "Fortellerstemme",
      "wedding_video_production": "Bryllupsvideoproduksjon",
      "fire_damage_cleanup_repair": "Brannskadeopprydding/reparasjon",
      "water_damage_cleanup_repair": "Rensing etter vannskader",
      "water_damage_flooring": "Gulvbelegg",
      "water_damage_mold_inspection": "Inspeksjon av mugg",
      "water_damage_mold_removal": "Fjerning av mugg",
      "water_damage_other": "Annen/annet",
      "water_damage_painting": "Maleri",
      "water_damage_pest_control": "Skadedyrkontroll",
      "water_damage_plumbing": "Rørleggerarbeid",
      "water_damage_remodeling": "Ombygging",
      "water_damage_roofing": "Taktekking",
      "water_damage_sewage_cleanup": "Rensing av avløpsvann",
      "adult_weight_loss_programs": "Vekttapsprogrammer for voksne",
      "diet_and_nutrition_counseling": "Kost- og ernæringsrådgivning",
      "kids_weight_loss_programs": "Vekttapsprogrammer for barn",
      "metabolic_testing": "Metabolsk testing",
      "weight_loss_consultation_and_training": "Konsultasjon og opplæring",
      "weight_loss_fitness_programs": "Treningsprogrammer",
      "weight_loss_meal_planning": "Måltidsplanlegging",
      "weight_loss_personal_training": "Personlig kurs",
      "weight_loss_service_other": "Annen/annet",
      "weight_loss_wellness_programs": "Velværeprogrammer",
      "glass_and_mirror_cleaning": "Glass og rengjøring av speil",
      "gutter_cleaning": "Rensing av takrenner",
      "power_pressure_washing": "Kraftvask/høytrykksvask",
      "rooftop_skylight_cleaning": "Rensing av tak og takvindu",
      "window_cleaner_other": "Annen/annet",
      "window_cleaning": "Rensing av vinduer",
      "door_installation": "Dørinstallasjon",
      "door_repair": "Dørreparasjon",
      "glass_installation": "Glassinstallasjon",
      "window_boardup": "Avstengning",
      "window_installation": "Vinduinstallasjon",
      "window_repair": "Vindusreparasjon",
      "window_repair_other": "Annen/annet",
      "install_new_wiper_blades": "Montering av nye vindusviskerblader",
      "repair_power_window": "Reparer elektrisk vindu",
      "repair_water_leak": "Reparer vannlekkasje",
      "repair_windshield": "Reparere frontrute",
      "replace_rear_window": "Skifte bakrute",
      "replace_side_view_mirrors": "Reparere sidespeil",
      "replace_side_window": "Skifte sidevinduet",
      "replace_sunroof": "Skifte soltakglass",
      "replace_windshield": "Bytte ut frontrute",
      "windshield_other": "Annen/annet",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot Yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditasjon",
      "power_yoga": "Kraftyoga",
      "restorative": "Restituerende",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Annen/annet"
    }
  }
}
